import request from '@/tools/request';
import { uniqueByFieldName } from '@/tools/index.js';
// import accountManagement from '@/page/accountManagement/config/api.js';
import store from '@/store/index.js';
import { Loading, MessageBox } from 'element-ui';

const baseUrl = '/rest/cso/saas';

// export { accountManagement };

//基础配置 http://yapi.jimijiayuan.cn/project/657/interface/api/19517
export const baseConfig = () => request.post(`${baseUrl}/baseconfig/configs`);

export const dicArea = {
  queryProvince(data) {
    return request.post('/rest/ysh/oss/base/area', data);
  }, //获取用户 menuList
  queryCity(data) {
    return request.post('/rest/ysh/oss/base/area', data);
  }, //获取用户 menuList
  queryArea(data) {
    return request.post('/rest/ysh/oss/base/area', data);
  } //获取用户 menuList
};
// 发票相关
export const invoice = {
  queryDefaultAddressName(data) {
    return request.post(`${baseUrl}/invoiceOpen/queryDefaultAddressName`, data);
  },
  invoiceOpenListToBeOpened(data) {
    return request.post(
      `${baseUrl}/invoiceOpen/invoiceOpenListToBeOpened`,
      data
    );
    // return request.get(`${baseUrl}/invoiceOpen/invoiceOpenListToBeOpened`, {params:data});
  },
  invoiceOpenListUserInfo(data) {
    return request.get(`${baseUrl}/invoiceOpen/invoiceOpenListUserInfo`, {
      params: data
    });
    // return request.get(`${baseUrl}/invoiceOpen/invoiceOpenListUserInfo`,{ params: data });
  },
  // http://yapi.jimijiayuan.cn/project/657/interface/api/18139
  HarvestAddress(data) {
    return request.get(`${baseUrl}/invoiceOpen/invoiceHarvestAddress`, {
      params: data
    });
    // return request.get(`${baseUrl}/invoiceOpen/invoiceOpenListUserInfo`,{ params: data });
  },
  // http://yapi.jimijiayuan.cn/project/657/interface/api/18191
  contentOfMakeOutAnInvoice(data) {
    const {
      formOptions: { _invoiceItems, defaultInvoicingTypeList }
    } = data;
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const res = await request.post(
        `${baseUrl}/invoiceOpen/contentOfMakeOutAnInvoice`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
      const {
        data: {
          data: { list }
        }
      } = res;
      res.data.data.list = list.map(i => ({
        ...i,
        _invoiceItems: _invoiceItems,
        defaultInvoicingTypeList: defaultInvoicingTypeList
      }));
      resolve(res);
      // _invoiceItems
    });
  },

  submitToSave(data) {
    // return request.post(`${baseUrl}/invoiceOpen/submitToSave`,data,{
    return request.post(`${baseUrl}/invoiceOpen/submitToSave`, data, {
      // yapi:657
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },

  detail(data) {
    return request.post(`${baseUrl}/invoiceCsoInfo/detail`, data);
  },
  // 委托开票详情 http://yapi.jimijiayuan.cn/project/657/interface/api/18283
  detailOfCommission(data) {
    return request.get(`${baseUrl}/invoiceOpen/detailsOnTheInvoice`, {
      params: data
    });
  },
  // 导出自然人发票 http://yapi.jimijiayuan.cn/project/657/interface/api/19559
  downloadDetailsOnTheInvoice(data) {
    return request.get(`${baseUrl}/invoiceOpen/downloadDetailsOnTheInvoice`, {
      params: data
    });
  },
  save(data) {
    return request.post(`${baseUrl}/invoiceCsoInfo/save`, data);
  },
  del(data) {
    return request.post(
      `${baseUrl}/invoiceCsoInfo/deleteCsoReceiptAddress`,
      data
    );
  },
  // 0申请中（已申请发票）  1 待审核 （待审核发票） 2 已开票(已开票) 3 已驳回（已驳回发票）
  queryInvoiceList(data) {
    return request.post(`${baseUrl}/invoice/queryInvoiceList`, data);
  },
  queryInvoiceOrder(data) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const respond = await request.post(
        `${baseUrl}/invoice/queryInvoiceOrder`,
        data
      );
      const {
        data: {
          data: { list }
        }
      } = respond;
      respond.data.data.list = list.map(i => {
        return {
          ...i,
          invoiceApplyId: data.id,
          _invoiceBusinessType: data.invoiceBusinessType
        };
      });

      resolve(respond);
    });
  },
  queryInvoiceDetail(data) {
    return request.post(`${baseUrl}/invoice/queryInvoiceDetail`, data);
  },
  queryAllAddressName(data) {
    return request.post(`${baseUrl}/invoiceOpen/queryAllAddressName`, data);
  },
  InvoiceAddressInfo(data) {
    return request.post(`${baseUrl}/invoiceOpen/InvoiceAddressInfo`, data);
  },
  supplierList(data) {
    return request.post(`${baseUrl}/invoiceOpen/supplierList`, data);
  },
  invoiceStatistics(data) {
    return request.post(`${baseUrl}/invoiceOpen/invoiceStatistics`, data);
  },
  invoiceOpenList(data) {
    return request.post(`${baseUrl}/invoiceOpen/invoiceOpenList`, data);
  },
  supplierItem(data) {
    return request.post(`${baseUrl}/invoiceOpen/supplierItem`, data);
  },
  openInvoiceContent(data) {
    return request.post(`${baseUrl}/invoiceOpen/openInvoiceContent`, data);
  },
  saveInvoice(data) {
    return request.post(`${baseUrl}/invoiceOpen/saveInvoice`, data);
  },
  // 审核 2 已开票 3 已驳回
  reviewTheSubmitted(data) {
    return request.post(`${baseUrl}/invoice/reviewTheSubmitted`, data);
  },

  //打款金额列表 http://yapi.jimijiayuan.cn/project/657/interface/api/12207
  amountOfMoney(data) {
    return request.post(`${baseUrl}/invoiceOpen/amountOfMoney`, data);
  },

  // 开票记录
  recordsOfMakeOutAnInvoice(data) {
    // return request.post(`${baseUrl}/invoice/recordsOfMakeOutAnInvoice`, data, !);
    return request.post(`${baseUrl}/invoice/recordsOfMakeOutAnInvoice`, data);
  }
};

export const dicQueryList = data => {
  return request.post('/rest/dic/queryList', data);
}; //字典列表
export const importSupplementData = `${baseUrl}/projectTask/importSupplementData`;
export const importAccessData = `${baseUrl}/projectTask/importMarketAccessSupplementData`;
export const caseMag = {
  projectList(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingliProject/projectList',
      data
    );
  },
  saveData(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingliProject/addUpdateProject',
      data
    );
  },
  del(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingliProject/deleteProject',
      data
    );
  },
  search(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingliProject/enterpriseList',
      data
    );
  },
  getList(data) {
    return request.post('/rest/doctor/assistant/oss//bingli/bingliList', data);
  },
  projectDetail(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingliProject/loadProject',
      data
    );
  },
  pass(data) {
    return request.post('/rest/doctor/assistant/oss/bingli/authBingli', data);
  },
  listDetail(data) {
    return request.post('/rest/doctor/assistant/oss/bingli/loadBingli', data);
  },
  save(data) {
    return request.post(
      '/rest/doctor/assistant/oss/bingli/addUpdateBingli',
      data
    );
  },
  deleteBingli(data) {
    return request.post('/rest/doctor/assistant/oss/bingli/deleteBingli', data);
  }
};
export const dicQueryInfo = data => {
  return request.post('/rest/dic/queryInfo', data);
}; //字典详情

export const projectSettled = {
  //项目入驻/退出
  projectSettledInList(data) {
    return request.post(`${baseUrl}/projectSettled/projectSettledInList`, data);
  },
  projectSettledOutList(data) {
    return request.post(
      `${baseUrl}/projectSettled/projectSettledOutList`,
      data
    );
  },
  auditSettledOut(data) {
    return request.post(`${baseUrl}/projectSettled/auditSettledOut`, data);
  },
  crmUserlDetail(data) {
    //经营者和个体信息查询
    return request.post(`${baseUrl}/projectSettled/crmUserlDetail`, data);
  },
  updateCrmUserlDetail(data) {
    //经营者和个体信息查询
    return request.post(`${baseUrl}/projectSettled/updateCrmUserlDetail`, data);
  },
  // 项目入住列表 -- 申请入驻
  userEnterProjectPageList(data) {
    return request.post(
      `${baseUrl}/userEnterPject/userEnterProjectPageList`,
      data
    );
  },
  // 项目入住列表 -- 申请入驻 -- 审核拒绝
  userEnterProjectCheckNo(data) {
    return request.post(
      `${baseUrl}/userEnterPject/userEnterProjectCheckNo`,
      data
    );
  },
  // 项目入驻 - 申请名单 - 通过按钮
  applicationIn(data) {
    return request.post(`${baseUrl}/importInAdvance/applicationIn`, data);
  }
};
export const contractInformation = {
  contractFourLevelList(data) {
    //四级个人
    return request.post(
      `${baseUrl}/contractInformation/contractFourLevelList`,
      data
    );
  },
  fourLevelPersonalList(data) {
    //四级个人
    return request.post(
      `${baseUrl}/contractInformation/fourLevelPersonalList`,
      data
    );
  },
  contractFourLevelInfo(data) {
    //供应商详情
    return request.post(
      `${baseUrl}/contractInformation/contractFourLevelInfo`,
      data
    );
  },
  exporContractFourLevelList: `${baseUrl}/contractInformation/exporContractFourLevelList`, //导出
  exporfourLevelPersonalList: `${baseUrl}/contractInformation/exporfourLevelPersonalList`, //导出
  contractThreeLevelList1(data) {
    //三级个人
    return request.post(
      `${baseUrl}/contractInformation/contractThreeLevelList1`,
      data
    );
  },
  threeLevelPersonalList(data) {
    //三级个人
    return request.post(
      `${baseUrl}/contractInformation/threeLevelPersonalList`,
      data
    );
  },
  exporContractThreeLevelList1: `${baseUrl}/contractInformation/exporContractThreeLevelList1`, //导出
  exporthreeLevelPersonalList: `${baseUrl}/contractInformation/exporthreeLevelPersonalList`, //导出
  contractThreeLevelList2(data) {
    //三级个体
    return request.post(
      `${baseUrl}/contractInformation/contractThreeLevelList2`,
      data
    );
  },
  threeLevelGtList(data) {
    //三级个体
    return request.post(
      `${baseUrl}/contractInformation/threeLevelGtList`,
      data
    );
  },
  exporContractThreeLevelList2: `${baseUrl}/contractInformation/exporContractThreeLevelList2`, //导出
  exporthreeLevelGtList: `${baseUrl}/contractInformation/exporthreeLevelGtList`, //导出
  projetContractThreeLevelList1(data) {
    //三级个人
    return request.post(
      `${baseUrl}/contractInformation/projetContractThreeLevelList1`,
      data
    );
  },
  projectExporContractThreeLevelList1: `${baseUrl}/contractInformation/projectExporContractThreeLevelList1`, //导出
  projectContractthreeLevelList(data) {
    //三级个体
    return request.post(
      `${baseUrl}/contractInformation/projectContractthreeLevelList`,
      data
    );
  },
  projectExporContractThreeLevelList2: `${baseUrl}/contractInformation/projectExporContractThreeLevelList2`, //导出
  threeLevelDownloadUrl: `${baseUrl}/contractInformation/threeLevelDownloadUrl`, //导出
  contractCollection(data) {
    //补录
    return request.post(
      `${baseUrl}/contractInformation/contractCollection`,
      data
    );
  }
};
export const logout = data => {
  return request.post(`${baseUrl}/user/logout`, data);
};

export const dicSave = data => {
  return request.post('/rest/dic/save', data);
}; //添加修改字典

export const dicDel = data => {
  return request.post('/rest/dic/delete', data);
}; //删除字典
export const user = {
  queryUserList(data) {
    return request.post(`${baseUrl}/user/queryUserList`, data);
  }, // 用户列表 包括查询
  save(data) {
    return request.post(`${baseUrl}/user/save`, data);
  }, // 添加修改用户信息
  roleList(data) {
    return request.post(`${baseUrl}/user/roleList`, data);
  }, // 获取用户角色列表
  getUserRole(data) {
    return request.post(`${baseUrl}/user/getUserRole`, data);
  }, // 获取当前用户所有角色ID
  saveUserRole(data) {
    return request.post(`${baseUrl}/user/saveUserRole`, data);
  }, // 保存用户角色
  menuList(data) {
    return request.post(`${baseUrl}/user/menuList`, data);
  }, // 用户模块列表
  saveUserMenu(data) {
    return request.post(`${baseUrl}/user/saveUserMenu`, data);
  } // 用户模块列表
};
//电子合同
export const eContract = {
  threeLevelDownloadUrl: `${baseUrl}/electronicSign/threeLevelDownloadUrl`,
  threeLevelPersonContractlist(data) {
    //合同管理--三级个人 合同查询
    return request.post(
      `${baseUrl}/electronicSign/threeLevelPersonContractlist`,
      data
    );
  },
  threeLevelEntContractlist(data) {
    //合同管理--三级个体合同查询
    return request.post(
      `${baseUrl}/electronicSign/threeLevelEntContractlist`,
      data
    );
  },
  threeLevelContractAdd(data) {
    //补录合同保存
    return request.post(
      `${baseUrl}/electronicSign/threeLevelContractAdd`,
      data
    );
  },
  xrkContractList(data) {
    return request.post(`${baseUrl}/electronicSign/xrkContractList`, data);
  }, // 用户列表 包括查询
  gysContractList(data) {
    return request.post(`${baseUrl}/electronicSign/gysContractList`, data);
  },
  dianziContractList(data) {
    return request.post(`${baseUrl}/electronicSign/dianziContractList`, data);
  },
  fadanCompanyList(data) {
    return request.post(`${baseUrl}/electronicSign/fadanCompanyList`, data);
  },
  gysList(data) {
    return request.post(`${baseUrl}/electronicSign/gysList`, data);
  },
  csoAndGysList(data) {
    return request.post(`${baseUrl}/electronicSign/csoAndGysList`, data);
  },
  firstSign(data) {
    return request.post(`${baseUrl}/signHT/firstSign`, data);
  },
  firstYshSign(data) {
    return request.post(`${baseUrl}/signHT/firstYshSign`, data);
  },
  lookContract(data) {
    return request.post(`${baseUrl}/signHT/lookContract`, data);
  },
  gysSignHt(data) {
    //供应商签约
    return request.post(`${baseUrl}/signHT/gysSignHt`, data);
  },
  lookCsoGysContract(data) {
    //查看供应商合同
    return request.post(`${baseUrl}/signHT/lookCsoGysContract`, data);
  },
  lookXrkContract(data) {
    //查看向日葵合同
    return request.post(`${baseUrl}/signHT/lookXrkContract`, data);
  },
  firstYshSignDownloadUrl(data) {
    //下载医生汇电子结算单
    return request.get(`${baseUrl}/signHT/firstYshSignDownloadUrl`, {
      params: data
    });
  },
  firstSignDownloadUrl(data) {
    //下载电子结算单
    return request.get(`${baseUrl}/signHT/firstSignDownloadUrl`, {
      params: data
    });
  },
  lookCsoGysContractDownloadUrl(data) {
    //下载供应商合同
    return request.get(`${baseUrl}/signHT/lookCsoGysContractDownloadUrl`, {
      params: data
    });
  },
  lookXrkContractDownloadUrl(data) {
    //下载向日葵合同
    return request.get(`${baseUrl}/signHT/lookXrkContractDownloadUrl`, {
      params: data
    });
  },
  signingPlatformContract(data) {
    //平台服务费签约
    return request.post(`${baseUrl}/signHT/signingPlatformContract`, data);
  },
  firstYshSignDownloadUrl2: `${baseUrl}/signHT/firstYshSignDownloadUrl`,
  firstSignDownloadUrl2: `${baseUrl}/signHT/firstSignDownloadUrl`,
  firstYshSignDownloadUrl3: `${baseUrl}/signHT/firstAspYshSignDownloadUrl`,
  firstSignDownloadUrl3: `${baseUrl}/signHT/firstAspSignDownloadUrl`,
  //电子结算单下载模板
  firstSignDownloadUrlMould: `${baseUrl}/ecloudOneSideSgin/downLoadContractTemplate`,
  lookCsoGysContractDownloadUrl2: `${baseUrl}/signHT/lookCsoGysContractDownloadUrl`,
  lookXrkContractDownloadUrl2: `${baseUrl}/signHT/lookXrkContractDownloadUrl`
};
export const csoUserKz = {
  addUpdateCsoUserKzDetail(data) {
    //获取乙方用户扩展详情
    return request.post(
      `${baseUrl}/csoUserEnterprise/addUpdateCsoUserKzDetail`,
      data
    );
  },
  csoUserKzDetail(data) {
    //完善用户企业扩展
    return request.post(`${baseUrl}/csoUserEnterprise/csoUserKzDetail`, data);
  }
};

export const role = {
  queryRole(data) {
    return request.post(`${baseUrl}/role/queryRole`, data);
  }, //获取用户 menuList
  saveRole(data) {
    return request.post(`${baseUrl}/role/saveRole`, data);
  }, //角色保存
  updateRole(data) {
    return request.post(`${baseUrl}/role/updateRole`, data);
  }, //角色修改
  getRuleId(data) {
    return request.post(`${baseUrl}/role/getRuleId`, data);
  }, //根据角色获取权限ID
  saveRoleRule(data) {
    return request.post(`${baseUrl}/role/saveRoleRule`, data);
  } //角色绑定权限
};
export const permission = {
  // 资源
  queryPermissionPage(data) {
    return request.post(`${baseUrl}/rule/queryPermissionPage`, data);
  }, //权限列表
  savePermission(data) {
    return request.post(`${baseUrl}/rule/savePermission`, data);
  }, //角色保存
  updatePermission(data) {
    return request.post(`${baseUrl}/rule/updatePermission`, data);
  } //修改权限
};
export const rule = {
  queryRule(data) {
    return request.post(`${baseUrl}/rule/queryRule`, data);
  }, //获取用户 menuList
  saveRule(data) {
    return request.post(`${baseUrl}/rule/saveRule`, data);
  }, //角色保存
  updateRule(data) {
    return request.post(`${baseUrl}/rule/updateRule`, data);
  }, //角色修改
  getPermissionByRuleId(data) {
    return request.post(`${baseUrl}/rule/getPermissionByRuleId`, data);
  }, //根据权限ID获取资源ID集合
  updateRulePermission(data) {
    return request.post(`${baseUrl}/rule/updateRulePermission`, data);
  }, //给权限设置资源
  queryPermissionPage(data) {
    return request.post(`${baseUrl}/rule/queryPermissionPage`, data);
  } //权限列表
};
export const roleMenu = {
  //模块
  queryMenuByQuery(data) {
    return request.post(`${baseUrl}/role/queryMenuByQuery`, data);
  }, //获取LIST
  saveMenu(data) {
    return request.post(`${baseUrl}/role/saveMenu`, data);
  }, //角色保存
  updateMenu(data) {
    return request.post(`${baseUrl}/role/updateMenu`, data);
  }, //角色修改
  queryMenu(data) {
    return request.post(`${baseUrl}/role/queryMenu`, data);
  }, //模块查询父子级  获取父级集合
  del(data) {
    return request.post(`${baseUrl}/role/deleteMenu`, data);
  }
};
export const updatePassword = data => {
  return request.post(`${baseUrl}/user/updatePassword`, data);
}; // 用户自己修改密码

//
export const riskControl = {
  academy: {
    detail(data = {}) {
      return request.post(`${baseUrl}/xsbfRisk/queryXsbfRiskInfo`, data);
    },
    update(data) {
      return request.post(`${baseUrl}/xsbfRisk/updateOrAddXsbfRiskInfo`, data);
    },
    list(data) {
      return request.get(`${baseUrl}/xsbfRisk/updateRecordList`, {
        params: data
      });
    },
    updateTime() {
      return request.get(`${baseUrl}/xsbfRisk/timeTaskOfEnableDt`);
    }
  },
  otc: {
    detail(data = {}) {
      return request.post(`${baseUrl}/otcRisk/queryOtcRiskInfo`, data);
    },
    update(data) {
      return request.post(`${baseUrl}/otcRisk/updateOrAddOtcRiskInfo`, data);
    },
    list(data) {
      return request.get(`${baseUrl}/otcRisk/updateRecordList`, {
        params: data
      });
    },
    updateTime() {
      return request.get(`${baseUrl}/otcRisk/timeTaskOfEnableDt`);
    }
  },
  lvlHospital: {
    detail(data = {}) {
      return request.post(`${baseUrl}/djyyRisk/queryDjyyRiskInfo`, data);
    },
    update(data) {
      return request.post(`${baseUrl}/djyyRisk/updateOrAddDjyyRiskInfo`, data);
    },
    list(data) {
      return request.get(`${baseUrl}/djyyRisk/updateRecordList`, {
        params: data
      });
    },
    updateTime() {
      return request.get(`${baseUrl}/djyyRisk/timeTaskOfEnableDt`);
    }
  },
  baseHospital: {
    detail(data = {}) {
      return request.post(`${baseUrl}/jcyljgRisk/queryJcyljgRiskInfo`, data);
    },
    update(data) {
      return request.post(
        `${baseUrl}/jcyljgRisk/updateOrAddJcyljgRiskInfo`,
        data
      );
    },
    list(data) {
      return request.get(`${baseUrl}/jcyljgRisk/updateRecordList`, {
        params: data
      });
    },
    updateTime() {
      return request.get(`${baseUrl}/jcyljgRisk/timeTaskOfEnableDt`);
    }
  },
  digital: {
    detail(data) {
      //查询
      return request.post(`${baseUrl}/szbfRisk/querySzbfRiskInfo`, data);
    },
    update(data) {
      //修改
      return request.post(`${baseUrl}/szbfRisk/updateOrAddSzbfRiskInfo`, data);
    },
    list(data) {
      //查询列表
      return request.post(`${baseUrl}/szbfRisk/updateRecordList`, data);
    }
  },
  digitalSurvey: {
    // 数字问卷风控保持或修改接口
    update(data) {
      return request.post(`${baseUrl}/szwjRisk/updateSzwjRiskInfo`, data);
    },
    //查询数字问卷风控
    detail(data) {
      return request.post(`${baseUrl}/szwjRisk/querySzwjRiskInfo`, data);
    },
    //查询历史数字问卷风控修改记录
    list(data) {
      return request.post(`${baseUrl}/szwjRisk/querySzwjRiskInfoHistory`, data);
    }
  },
  elseComponent: {
    detail(data) {
      return request.post(`${baseUrl}/risk/projectRiskData`, data);
    }
  },
  //风控详情调研场景
  investigate: {
    dcwjRiskDetail(data) {
      return request.post(`${baseUrl}/dcwjRisk/detail`, data);
    },
    dcwjRiskSave(data) {
      return request.post(`${baseUrl}/dcwjRisk/save`, data, {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        notUseQs: true
      });
    },
    dcwjRiskHistory(data) {
      return request.post(`${baseUrl}/dcwjRisk/history`, data);
    }
  },
  editScene: {
    detail(data = {}) {
      return request.post(
        `${baseUrl}/makeSceneRisk/makeSceneRiskInfoByProject`,
        data
      );
    },
    update(data) {
      return request.post(
        `${baseUrl}/makeSceneRisk/updateMakeSceneRiskInfoByProject`,
        data
      );
    },
    list(data) {
      return request.post(
        `${baseUrl}/makeSceneRisk/makeSceneRiskHistoryRecordByProject`,
        data
      );
    },
    updateTime() {
      return request.get(`${baseUrl}/xsbfRisk/timeTaskOfEnableDt`);
    }
  }
};
//////////////////////////////////////////////SaaS 乙方/////////////////////////////////////////////////////////////////////
export const login = {
  login(data) {
    return request.post(`${baseUrl}/user/login`, data);
  },
  sendSubmitMsg(data) {
    return request.post(`${baseUrl}/projectTask/sendSubmitMsg`, data);
  },
  sendMessageCode(data) {
    return request.post(`${baseUrl}/user/sendMessageCode`, data);
  },
  getUserDataByToken(data) {
    return request.post(`${baseUrl}/user/getUserDataByToken`, data);
  },
  passwordLogin(data) {
    return request.post(`${baseUrl}/user/passwordLogin`, data);
  },
  validatePhoneAndSmscodeForResetPassword(data) {
    return request.post(
      `${baseUrl}/user/validatePhoneAndSmscodeForResetPassword`,
      data
    );
  },
  resetUserPwd(data) {
    return request.post(`${baseUrl}/user/resetUserPwd`, data);
  },
  //设置密码
  setUserPwd(data) {
    return request.post(`${baseUrl}/user/setUserPwd`, data);
  },
  verifyImgCode: `${baseUrl}/user/verifyImgCode`
};
export const company = {
  //企业管理
  list(data) {
    return request.post(`${baseUrl}/enterprise/list`, data);
  }, //获取LIST
  add(data) {
    return request.post(`${baseUrl}/enterprise/save`, data);
  },
  del(data) {
    return request.post(`${baseUrl}/enterprise/delete`, data);
  }
};
export const saler = {
  //代表
  list(data) {
    return request.post(`${baseUrl}/enterprise/agentList`, data);
  }, //获取LIST
  del(data) {
    return request.post(`${baseUrl}/enterprise/deleteAgent`, data);
  },
  add(data) {
    return request.post(`${baseUrl}/enterprise/saveUserAndAgent`, data);
  },
  batchAdd(data) {
    return request.post(`${baseUrl}/enterprise/batchImportUserAndAgent`, data);
  }
};
export const visit = {
  //拜访管理
  list(data) {
    return request.post(`${baseUrl}/visit/list`, data);
  }, //获取LIST
  listHospital(data) {
    return request.post(
      `${baseUrl}/gradeHospitalAndMedicalOrg/taskRecordlist`,
      data
    );
  }, //获取LIST 等级医院 和 医疗设备
  pass(data) {
    return request.post(`${baseUrl}/visit/updatePassStatus`, data);
  },
  exportExcelData: `${baseUrl}/visit/exporXsbftData`, // 导出

  passHospital(data) {
    return request.post(
      `${baseUrl}/gradeHospitalAndMedicalOrg/updatePassStatus`,
      data
    );
  },

  listHospitalAll(data) {
    return request.post(`${baseUrl}/gradeHospitalAndMedicalOrg/pageList`, data);
  }, //获取LIST 等级医院 和 医疗设备
  exportExcelDataHospital: `${baseUrl}/gradeHospitalAndMedicalOrg/exportGradeHospitalData`, // 导出
  exportMedicalOrgData: `${baseUrl}/gradeHospitalAndMedicalOrg/exportMedicalOrgData`, // 导出

  exportTaskSummary: `${baseUrl}/gradeHospitalAndMedicalOrg/exportTaskSummary`, // 等级医院和基层医疗机构任务汇总导出
  exportDoctorBingliTaskSummary: `${baseUrl}/userVisitPlan/exportDoctorBingliTaskSummary`, // 病例汇总导出
  exportUserVisitPlanList: `${baseUrl}/userVisitPlan/exportUserVisitPlanList`, // 学术拜访汇总导出
  exportDcwjDepartmentList: `${baseUrl}/diaoChaWenJuan/exportDcwjDepartmentList`, // 医学助手项目调研(调查问卷)任务汇总导出
  exportOtcTaskSummary: `${baseUrl}/OTCVisit/exportOtcTaskSummary`, // OTC拜访任务汇总导出
  exportYshdcwjTaskSummary: `${baseUrl}/DoctorQuestion/exportYshdcwjTaskSummary`, // 医生汇调查问卷任务汇总导出
  exportRecordSummaryList: `${baseUrl}/channel/exportRecordSummaryList`, // 线上推广任务汇总导出
  exportSelectDepartmentList: `${baseUrl}/OTCVisit/exportSelectDepartmentList` // 科室会/患教会任务汇总导出
};
//协定服务
export const protocolService = {
  auditAgreementService(data) {
    return request.post(
      `${baseUrl}/agreementServices/auditAgreementService`,
      data
    );
  },
  getTaskRecordList(data) {
    return request.post(`${baseUrl}/agreementServices/getTaskRecordList`, data);
  },
  getAgreementTaskSummary(data) {
    return request.post(
      `${baseUrl}/agreementServices/getAgreementTaskSummary`,
      data
    );
  },
  deleteAgreementServiceFile(data) {
    return request.post(
      `${baseUrl}/agreementServices/deleteAgreementServiceFile`,
      data
    );
  },
  updateAgreementServicePassStatus(data) {
    return request.post(
      `${baseUrl}/agreementServices/updateAgreementServicePassStatus`,
      data
    );
  },
  submitUploadFile(data) {
    return request.post(`${baseUrl}/agreementServices/submitUploadFile`, data);
  },
  submitSubmitDetail(data) {
    return request.post(`${baseUrl}/agreementService/submitSubmitDetail`, data);
  },
  loadSubmitDetail(data) {
    return request.post(`${baseUrl}/agreementService/loadSubmitDetail`, data);
  },
  downloadAgreementServiceFile: `${baseUrl}/agreementService/downloadAgreementServiceFile`,
  exportTaskRecordList: `${baseUrl}/agreementServices/exportTaskRecordList`,
  exportAgreementTaskSummary: `${baseUrl}/agreementServices/exportAgreementTaskSummary`,
  agreementServicesContractUpload: `${baseUrl}/upload/agreementServicesContractUpload`,
  // 更新协定服务结算金额
  updateAgreeServiceAmount(data) {
    return request.post(`${baseUrl}/confirm/updateAgreeServiceAmount`, data);
  },
  // 协定服务上传结算金额excel上传
  importSettlementAmount: `${baseUrl}/confirm/importSettlementAmount`,
  // 协定服务添加任务量
  addTaskNum(data) {
    return request.post(`${baseUrl}/confirm/addTaskNum`, data, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      notUseQs: true
    });
  },
  // 协定服务添加任务量 - 人员列表
  listPeopleByProjectId(data) {
    return request.post(`${baseUrl}/confirm/listPeopleByProjectId`, data);
  },
  // 协定服务添加任务量 - 全部添加
  listPeopleByProjectIdALL(data) {
    return request.post(`${baseUrl}/confirm/listPeopleByProjectIdALL`, data);
  },
  // 下载列表数据
  agreementServiceDownloadTheList: `${baseUrl}/agreementServices/agreementServiceDownloadTheListNew`
};
export const survey = {
  //拜访管理
  list(data) {
    return request.post(`${baseUrl}/dcwj/dcwjList`, data);
  }, //获取LIST
  edit(data) {
    return request.post(`${baseUrl}/dcwj/saveOrUpdateDcwj`, data);
  },
  enterpriseList(data) {
    return request.post(`${baseUrl}/dcwj/enterpriseList`, data);
  },
  detail(data) {
    return request.post(`${baseUrl}/dcwj/getDcwjById`, data);
  },
  selectDcwjDepartmentList(data) {
    //医学助手任务汇总
    return request.post(
      `${baseUrl}/diaoChaWenJuan/selectDcwjDepartmentList`,
      data
    );
  },
  crmDcwjProjectList(data) {
    //医学助手项目下拉
    return request.post(`${baseUrl}/diaoChaWenJuan/crmDcwjProjectList`, data);
  },
  pageList(data) {
    //医生联盟任务汇总
    return request.post(`${baseUrl}/DoctorQuestion/pageList`, data);
  },
  QuestDoctorProList(data) {
    //医生联盟项目下拉
    return request.post(`${baseUrl}/DoctorQuestion/QuestDoctorProList`, data);
  }
};
export const customer = {
  //客户管理
  list(data) {
    return request.post(`${baseUrl}/customer/list`, data);
  } //获取LIST
};
export const userMt = {
  //用户管理
  list(data) {
    return request.post(`${baseUrl}/crmUser/crmUserlList`, data);
  }, //获取LIST
  freeze(data) {
    return request.post(`${baseUrl}/crmUser/freezeCrmUser`, data);
  } //获取LIST
};
export const drug = {
  //药品管理
  list(data) {
    return request.post(`${baseUrl}/medicinal/medicinalList`, data);
  } //获取LIST
};
export const feedback = {
  //反馈
  list(data) {
    return request.post(`${baseUrl}/feedback/feedbackList`, data);
  } //获取LIST
};
export const initImport = `${baseUrl}/initialization/import`; //初始化导入
export const channel = {
  // 专区
  list(data) {
    //获取LIST
    return request.post(`${baseUrl}/channel/channelList`, data);
  },
  companyList(data) {
    //获取企业LIST
    return request.post(`${baseUrl}/channel/enterpriseList`, data);
  },
  post(data) {
    //添加修改
    return request.post(`${baseUrl}/channel/saveChannel`, data);
  }, //保存
  detail(data) {
    return request.post(`${baseUrl}/channel/channelDetail`, data);
  }, //保存
  queryChannelCourseList(data) {
    //频道关联视频列表
    return request.post(`${baseUrl}/channel/channelResourceList`, data);
  },
  postChannelCourse(data) {
    //频道添加课程接口
    return request.post(`${baseUrl}/channel/saveChannelResource`, data);
  },
  queryByCourseType(data) {
    //添加修改专区课程
    return request.post(`${baseUrl}/channel/saveChannelResource`, data);
  },
  channelCourseDetail(data) {
    //专区课程详情
    return request.post(`${baseUrl}/channel/channelResourceDetail`, data);
  },
  yshCourse(data) {
    // 获取医生汇课程列表
    return request.post(`${baseUrl}/channel/yshCourseList`, data);
  },
  queryChannelInformationOrCaseList(data) {
    //频道关联资讯病例列表
    return request.post(`${baseUrl}/channel/channelContentList`, data);
  },
  channelContentDetail(data) {
    //获取关联内容详情
    return request.post(`${baseUrl}/channel/channelContentDetail`, data);
  },
  postChannelContent(data) {
    //频道添加资讯或者病例接口
    return request.post(`${baseUrl}/channel/saveChannelContent`, data);
  },
  // 查询资讯或者病例
  queryInformationOrCase(data) {
    return request.post(`${baseUrl}/channel/yshContentList`, data);
  },
  //专区
  channelList(data) {
    return request.post(`${baseUrl}/channelManage/channelList`, data);
  },
  projectList(data) {
    return request.post(`${baseUrl}/channelManage/projectList`, data);
  },
  deleteChannel(data) {
    return request.post(`${baseUrl}/channelManage/deleteChannel`, data);
  },
  loadChannel(data) {
    return request.post(`${baseUrl}/channelManage/loadChannel`, data);
  },
  addUpdateChannel(data) {
    return request.post(`${baseUrl}/channelManage/addUpdateChannel`, data);
  },
  picUrlInformation(data) {
    return request.post(`${baseUrl}/channelManage/picUrlInformation`, data);
  },
  channelInformationList(data) {
    return request.post(
      `${baseUrl}/channelManage/channelInformationList`,
      data
    );
  },
  loadChannelProject(data) {
    return request.post(`${baseUrl}/channelManage/loadChannelProject`, data);
  },
  updateChannelProject(data) {
    return request.post(`${baseUrl}/channelManage/updateChannelProject`, data);
  },
  selectChannel(data) {
    return request.post(`${baseUrl}/channelManage/selectChannel`, data);
  },
  selectMonthTask(data) {
    return request.post(`${baseUrl}/channelManage/selectMonthTask`, data);
  },
  // 获取数字专区用户分享数据月份
  getMonthTask(data) {
    return request.post(`${baseUrl}/channelManage/getMonthTask`, data);
  }
};
export const information = {
  //资讯
  informationList(data) {
    return request.post(`${baseUrl}/information/informationList`, data);
  },
  saveInformation(data) {
    return request.post(`${baseUrl}/information/saveInformation`, data);
  },
  loadInformationVideo(data) {
    return request.post(`${baseUrl}/information/loadInformationVideo`, data);
  },
  deleteInformationVideo(data) {
    return request.post(`${baseUrl}/information/deleteInformationVideo`, data);
  },
  channelProjectList(data) {
    return request.post(`${baseUrl}/information/channelProjectList`, data);
  }
};
export const hgtgCount = {
  // 线上推广 专区
  hgtgQueryChannel(data) {
    return request.post(`${baseUrl}/hgtgCount/hgtgQueryChannel`, data);
  }, // 专区统计管理参数   pageNo   、pageSize、channelName（专区名称）、startDate （开始时间 天）、endDate（结束时间、天）
  hgtgQueryChannelPeople(data) {
    return request.post(`${baseUrl}/hgtgCount/hgtgQueryChannelPeople`, data);
  }, // 专区统计管理 查看参数   pageNo   、pageSize、channelId（专区id）、channelName（专区名称）、fullName（人员姓名）、startDate （开始时间 天）、endDate（结束时间、天）
  hgtgQueryContent(data) {
    return request.post(`${baseUrl}/hgtgCount/hgtgQueryContent`, data);
  }, // 内容统计管理 参数   pageNo   、pageSize、channelName（专区名称）、contentName（内容名称）、contentType（类型 1 课程 2 资讯 3 病例）、startDate （开始时间 天）、endDate（结束时间、天）
  hgtgQueryContentOne(data) {
    return request.post(`${baseUrl}/hgtgCount/hgtgQueryContentOne`, data);
  } // 内容统计管理查看参数   pageNo   、pageSize、channelId（专区id 必须传）、fullName（人员名称）、phone（手机号）、startDate （开始时间 天）、endDate（结束时间、天）
};

export const promotion = {
  // 线上推广 统计列表
  doctorList(data) {
    return request.post(`${baseUrl}/promotion/doctorList`, data);
  }, // 推广人员统计列表
  saveData(data) {
    return request.post(`${baseUrl}/promotion/saveData`, data);
  }, // 新增
  importExcelData: `${baseUrl}/promotion/importExcelData`, // 导入
  exportExcelData: `${baseUrl}/promotion/exportExcelData`, // 导出
  hgtgQueryContentPeople(data) {
    return request.post(`${baseUrl}/hgtgCount/hgtgQueryContentPeople`, data);
  } // 推广线上-查看 参数   pageNo   、pageSize、doctorId（医生id 必须传）、channelName（专区名称）、contentName（内容名称）、contentType（内容类型 1 课程 2 资讯 3 病例）、startDate （开始时间 天）、endDate（结束时间、天）
};
export const spread = {
  // 线上推广 项目调研
  // 列表
  taskMateList(data) {
    return request.post(`${baseUrl}/taskMate/taskMateList`, data);
  },
  // 新任务列表
  taskProjectList(data) {
    return request.post(`${baseUrl}/taskMate/taskProjectList`, data);
  },
  saveData(data) {
    return request.post(`${baseUrl}/taskMate/updateTaskSum`, data);
  }, // 线上推广修改
  detail(data) {
    return request.post(`${baseUrl}/taskMate/loadUserTask`, data);
  }, // 线上推广修改
  zoneList(data) {
    return request.post(`${baseUrl}/taskMate/zhuanquSearch`, data);
  }, // 查询专区

  projectSearch(data) {
    return request.post(`${baseUrl}/taskMate/projectSearch`, data);
  }, // 查询项目
  del(data) {
    return request.post(`${baseUrl}/taskMate/delTaskSum`, data);
  }, // 删除
  importHgtgData(data) {
    //线上推广导入
    return request.post(`${baseUrl}/taskMate/importHgtgData`, data);
  },
  importXmdyData(data) {
    //调研问卷导入
    return request.post(`${baseUrl}/taskMate/importXmdyData`, data);
  }
};
export const contract = {
  // 线上推广 项目调研
  list(data) {
    // 列表
    return request.post(`${baseUrl}/userSigning/list`, data);
  },
  search(data) {
    // 签约平台
    return request.post(`${baseUrl}/userSigning/companyList`, data);
  },
  detail(data) {
    // 详情
    return request.post(`${baseUrl}/userSigning/signingDetail`, data);
  }
};
export const academy = {
  // 学术拜访
  xueshuProjectList(data) {
    // 列表
    return request.post(`${baseUrl}/project/xueshuProjectList`, data);
  },
  addUpdateXueshuProject(data) {
    // 新增/修改
    return request.post(`${baseUrl}/project/addUpdateXueshuProject`, data);
  },
  loadXueshuProject(data) {
    // 详情
    return request.post(`${baseUrl}/project/loadXueshuProject`, data);
  },
  deleteXueshuProject(data) {
    return request.post(`${baseUrl}/project/deleteXueshuProject`, data);
  },
  xueshuCustomerList(data) {
    // 详情
    return request.post(`${baseUrl}/project/xueshuCustomerList`, data);
  },
  pageList(data) {
    // 学术拜访-任务量统计-查询(任务汇总)
    return request.post(`${baseUrl}/userVisitPlan/pageList`, data);
  },
  taskDetail(data) {
    return request.post(`${baseUrl}/visit/selectXsbfTaskDetail`, data);
  }
};
export const hospital = {
  // 等级医院拜访 和 医疗设备
  xueshuProjectList(data) {
    // 列表
    return request.post(`${baseUrl}/project/xueshuProjectList`, data);
  },
  addUpdateXueshuProject(data) {
    // 新增/修改
    return request.post(`${baseUrl}/project/addUpdateXueshuProject`, data);
  },
  loadXueshuProject(data) {
    // 详情
    return request.post(`${baseUrl}/project/loadXueshuProject`, data);
  },
  deleteXueshuProject(data) {
    return request.post(`${baseUrl}/project/deleteXueshuProject`, data);
  },
  xueshuCustomerList(data) {
    // 详情
    return request.post(`${baseUrl}/project/xueshuCustomerList`, data);
  },
  pageList(data) {
    // 学术拜访-任务量统计-查询(任务汇总)
    return request.post(`${baseUrl}/userVisitPlan/pageList`, data);
  },
  taskDetail(data) {
    return request.post(
      `${baseUrl}/gradeHospitalAndMedicalOrg/selectTaskDetail`,
      data
    );
  }
};
export const otc = {
  // otc
  otcProjectList(data) {
    return request.post(`${baseUrl}/project/otcProjectList`, data);
  },
  addUpdateOtcProject(data) {
    return request.post(`${baseUrl}/project/addUpdateOtcProject`, data);
  },
  loadOtcProject(data) {
    return request.post(`${baseUrl}/project/loadOtcProject`, data);
  },
  deleteOtcProject(data) {
    return request.post(`${baseUrl}/project/deleteOtcProject`, data);
  },
  otcCustomer(data) {
    return request.post(`${baseUrl}/customer/otcCustomer`, data);
  },
  otcList(data) {
    return request.post(`${baseUrl}/visit/otcList`, data);
  },
  updateOtcAuditStatus(data) {
    return request.post(`${baseUrl}/visit/updateOtcAuditStatus`, data);
  },
  exportOtcVisitData: `${baseUrl}/visit/exportOtcVisitData`,
  provinceCityList(data) {
    return request.post(`${baseUrl}/project/provinceCityList`, data);
  },
  otcVisitPlanDetail(data) {
    return request.post(`${baseUrl}/visit/otcVisitPlanDetail`, data);
  },
  //OTC拜访 拜访计划表(任务汇总)
  SelectOTCVisitList(data) {
    return request.post(`${baseUrl}/OTCVisit/SelectOTCVisitList`, data);
  }
};
//导出项目任务量报表
export const exportProjectTaskExcel = `${baseUrl}/export/exportProjectTaskExcel`;
// 任务量导入 3 学术拜访  4 OTC 巡访  5 科室会  6 患教会
export const importXsbfData = `${baseUrl}/taskMate/importXsbfData`;
export const protocolServiceImport = `${baseUrl}/agreementService/importXcxProjectData`;
// 下载表格 1:项目调研任务导入表格 2:线上推广任务导入表格 3:学术拜访  4:OTC巡访  5:科室会  6:患教会
export const downloadCell = `${baseUrl}/taskMate/downloadCell`;
// 上传附件 doc,docx,xls,xlsx,ppt,pptx,pdf文件
export const fileUpload = `${baseUrl}/upload/fileUpload`;
// 上传图片
export const uploadImage = `${baseUrl}/upload/image`;
export const threeLevelContractUpload = `${baseUrl}/upload/threeLevelContractUpload`;
export const uploadImageAjax = data => request.post(uploadImage, data);

// ksh
export const ksh = {
  //科室会项目列表
  departmentProjectList(data) {
    return request.post(`${baseUrl}/project/departmentProjectList`, data);
  },
  //新增/修改
  addUpdateDepartmentProject(data) {
    return request.post(`${baseUrl}/project/addUpdateDepartmentProject`, data);
  },
  //加载单条数据
  loadDepartmentProject(data) {
    return request.post(`${baseUrl}/project/loadDepartmentProject`, data);
  },
  //删除
  deleteDepartmentProject(data) {
    return request.post(`${baseUrl}/project/deleteDepartmentProject`, data);
  },
  //拜访计划列表
  departmentMeetVisitList(data) {
    return request.post(`${baseUrl}/visit/departmentMeetVisitList`, data);
  },
  departmentVisitPlanDetail(data) {
    return request.post(`${baseUrl}/visit/departmentVisitPlanDetail`, data);
  },
  //拜访计划导出
  exportDepartmentMeetVisit: `${baseUrl}/visit/exportDepartmentMeetVisit`,
  //审核拜访计划
  updateDepartmentMeetVisitAuditStatus(data) {
    return request.post(
      `${baseUrl}/visit/updateDepartmentMeetVisitAuditStatus`,
      data
    );
  },
  //5科室会 6 患教会访 拜访计划查询-列表(项目汇总)
  selectDepartmentList(data) {
    return request.post(`${baseUrl}/OTCVisit/selectDepartmentList`, data);
  },
  selectDepartmentGroupList(data) {
    return request.post(`${baseUrl}/OTCVisit/selectDepartmentGroupList`, data);
  }
};

// hjh
export const hjh = {
  //患教会项目列表
  patientProjectList(data) {
    return request.post(`${baseUrl}/project/patientProjectList`, data);
  },
  //新增/修改
  addUpdatePatientProject(data) {
    return request.post(`${baseUrl}/project/addUpdatePatientProject`, data);
  },
  //加载单条数据
  loadPatientProject(data) {
    return request.post(`${baseUrl}/project/loadPatientProject`, data);
  },
  //删除
  deletePatientProject(data) {
    return request.post(`${baseUrl}/project/deletePatientProject`, data);
  },
  //患教会列表
  patientList(data) {
    return request.post(`${baseUrl}/visit/patientList`, data);
  },
  //患教会列表_导出
  exportPatientVisitData: `${baseUrl}/visit/exportPatientVisitData`,
  //审核拜访计划
  updatePatientAuditStatus(data) {
    return request.post(`${baseUrl}/visit/updatePatientAuditStatus`, data);
  },
  loadPatient(data) {
    return request.post(`${baseUrl}/visit/loadPatient`, data);
  },
  //5科室会 6 患教会访 拜访计划查询-列表(项目汇总)
  selectDepartmentList(data) {
    return request.post(`${baseUrl}/OTCVisit/selectDepartmentList`, data);
  }
};
export const health = {
  aiTaskList(data) {
    return request.post(`${baseUrl}/health/aiTaskList`, data);
  },
  exportAITaskList: `${baseUrl}/health/exportAITaskList`,
  auditAITask(data) {
    return request.post(`${baseUrl}/health/auditAITask`, data);
  },
  chatRecordDetail(data) {
    return request.post(`${baseUrl}/health/chatRecordDetail`, data);
  },
  casesSummaryDetail(data) {
    return request.post(`${baseUrl}/health/casesSummaryDetail`, data);
  },
  aiTaskSummaryList(data) {
    return request.post(`${baseUrl}/health/aiTaskSummaryList`, data);
  },
  exportAITaskSummaryList: `${baseUrl}/health/exportAITaskSummaryList`
};
// 项目
export const project = {
  //项目-任务分配列表
  taskList(data) {
    return request.post(`${baseUrl}/projectTask/taskList`, data); // 废弃
  },
  // 新项目-任务分配 -> 确认任务
  taskListNew(data) {
    return request.post(`${baseUrl}/projectTask/taskListNew`, data); // 废弃
  },
  // -项目-任务-提交
  submitTask(data) {
    return request.post(`${baseUrl}/projectTask/submitTask`, data);
  },
  // -项目-任务-导入 3 学术拜访  4 OTC 巡访  5 科室会  6 患教会
  importXsbfData: `${baseUrl}/projectTask/importXsbfData`,

  importMarketAccessData: `${baseUrl}/projectTask/importMarketAccessData`,
  // 学术/患教会/科室会-编辑项目产品信息
  updateProductData(data) {
    return request.post(`${baseUrl}/project/updateProductData`, data);
  },
  //OTC-编辑项目产品信息
  updateOtcProductData(data) {
    return request.post(`${baseUrl}/project/updateOtcProductData`, data);
  },
  //学术/OTC/科室/患教修改单价
  updateTaskPrice(data) {
    return request.post(`${baseUrl}/projectTask/updateTaskPrice`, data);
  },
  updateProjectPrice(data) {
    //学术/OTC/科室/患教-项目修改乙方价格
    return request.post(`${baseUrl}/project/updateProjectPrice`, data);
  }
};

export const dictionaries = {
  //开户
  bankList(data) {
    return request.post(`${baseUrl}/dictionaries/bankList`, data);
  },
  areaList(data) {
    return request.post(`${baseUrl}/dictionaries/areaList`, data);
  },
  // 获取 企业开户状态
  // offlineProject 1展示线上 2展示线下 3线上线下都展示
  isOpenAccount(data) {
    return request.post(`${baseUrl}/openAccount/isOpenAccount`, data);
  },
  userOpenDetail(data) {
    return request.post(`${baseUrl}/openAccount/userOpenDetail`, data);
  },
  addOpenAccount(data) {
    return request.post(`${baseUrl}/openAccount/addOpenAccount`, data);
  },
  recharge(data) {
    return request.post(`${baseUrl}/openAccount/recharge`, data);
  }
};
export const withdrawals = {
  //提现
  sendWithdrawalsMsg(data) {
    return request.post(`${baseUrl}/withdrawals/sendWithdrawalsMsg`, data);
  },
  submitWithdrawals(data) {
    return request.post(`${baseUrl}/withdrawals/submitWithdrawals`, data);
  },
  loadLastWithdrawals(data) {
    return request.post(`${baseUrl}/withdrawals/loadLastWithdrawals`, data);
  },
  firstSubmitWithdrawals(data) {
    return request.post(`${baseUrl}/withdrawals/firstSubmitWithdrawals`, data);
  },
  getAccountOutFee(data) {
    return request.post(`${baseUrl}/withdrawals/getAccountOutFee`, data);
  }
};
export const bingli = {
  // 病例
  // 病例管理
  bingliList(data) {
    return request.post(`${baseUrl}/bingli/bingliList`, data);
  },
  //病例项目管理
  projectList(data) {
    return request.post(`${baseUrl}/bingliProject/projectList`, data);
  },
  //病例项目管理-项目编辑
  addUpdateBingliProject(data) {
    return request.post(
      `${baseUrl}/bingliProject/addUpdateBingliProject`,
      data
    );
  },
  //病例项目管理-项目数据
  loadProject(data) {
    return request.post(`${baseUrl}/bingliProject/loadProject`, data);
  },
  //病例项目-分配任务列表
  bingliProjectTask(data) {
    return request.post(`${baseUrl}/bingliProject/bingliProjectTask`, data);
  },
  // 新 病例项目-分配任务列表
  bingliProjectTaskNew(data) {
    return request.post(`${baseUrl}/bingliProject/bingliProjectTaskNew`, data);
  },
  //病例项目-分配任务-完成
  updateBingliProjectTaskStatus(data) {
    return request.post(
      `${baseUrl}/bingliProject/updateBingliProjectTaskStatus`,
      data
    );
  },
  //病例项目-任务-下载
  downloadCell: `${baseUrl}/bingliProject/downloadCell`,
  //病例项目-任务-导入
  importBignliProjectData: `${baseUrl}/bingliProject/importBignliProjectData`,
  //病例管理-审核通过/不通过
  authBingli(data) {
    return request.post(`${baseUrl}/bingli/authBingli`, data);
  },
  //病例管理-加载单条
  loadBingli(data) {
    return request.post(`${baseUrl}/bingli/loadBingli`, data);
  },
  //病例管理-修改
  addUpdateBingli(data) {
    return request.post(`${baseUrl}/bingli/addUpdateBingli`, data);
  },
  //病例项目管理-任务量统计-查询列表(任务汇总)
  doctorBingliPageList(data) {
    return request.post(`${baseUrl}/userVisitPlan/doctorBingliPageList`, data);
  },
  //病例项目-任务-修改单价
  updateBingliTaskPrice(data) {
    return request.post(`${baseUrl}/bingliProject/updateBingliTaskPrice`, data);
  },
  //病例项目管理-修改项目乙方价格
  updateBingliProjectPrice(data) {
    return request.post(
      `${baseUrl}/bingliProject/updateBingliProjectPrice`,
      data
    );
  },
  exportBingLiExcell: `${baseUrl}/bingliProject/exportBingLiExcell`
};
//项目结算查询-获取列表
export const ProjectPayList = data =>
  request.post(`${baseUrl}/projectAygPay/projectList`, data);
//项目结算查询-需打款
export const selectGroupList = data =>
  request.post(`${baseUrl}/projectAygPay/selectGroupList`, data);

export const PageList = {
  //签约信息列表
  PageList(data) {
    return request.post(`${baseUrl}/crmAndDoctorUserSign/PageList`, data);
  },
  // 签约信息列表 项目搜索输入框下拉列表
  getGroupList(data) {
    return request.post(`${baseUrl}/crmAndDoctorUserSign/getGroupList`, data);
  },
  exportExcelData: `${baseUrl}/crmAndDoctorUserSign/exportPageList`
};

export const userTaskLuodi = {
  //支付明细-分页查询列表
  userTaskLoudiPageList(data) {
    return request.post(`${baseUrl}/projectAygPay/userTaskLoudiPageList`, data);
  },
  //支付明细-结算_查询所有
  userTaskLoudiList(data) {
    return request.post(`${baseUrl}/projectAygPay/userTaskLoudiList`, data);
  },
  //支付明细-id_type列表查询
  idAndTypeList(data) {
    return request.post(`${baseUrl}/userTaskLuodi/typeAndProjectIdList`, data);
  },
  //支付明细-下载导出Excell
  exportExcelData: `${baseUrl}/projectAygPay/exportExcelData`,
  //支付明细-价格汇总
  sumMoney(data) {
    return request.post(`${baseUrl}/projectAygPay/payCsoPrice`, data);
  },
  //支付明细-结算
  payTask(data) {
    return request.post(`${baseUrl}/projectAygPay/payTask`, data);
  }
};

export const nature = {
  //企业助手自然人查询
  selectEnterpriseList(data) {
    return request.post(`${baseUrl}/Nature/selectEnterpriseList`, data);
  },
  //医生汇自然人查询
  selectDoctorList(data) {
    return request.post(`${baseUrl}/Nature/selectDoctorList`, data);
  }
};

export const dcwj = {
  //CRM调查问卷-任务分配列表
  crmDcwjTaskList(data) {
    return request.post(`${baseUrl}/dcwjTask/crmDcwjTaskList`, data);
  },
  // 新 CRM调查问卷-任务分配列表
  crmDcwjTaskListNew(data) {
    return request.post(`${baseUrl}/dcwjTask/crmDcwjTaskListNew`, data);
  },
  //CRM调查问卷-列表  传 ID 为单条详情
  pageList(data) {
    return request.post(`${baseUrl}/diaoChaWenJuan/pageList`, data);
  },
  //CRM调查问卷-编辑 接口
  updateById(data) {
    return request.post(`${baseUrl}/diaoChaWenJuan/updateById`, data);
  },
  //CRM调查问卷-任务分配列表-提交
  submitCrmDcwjTask(data) {
    return request.post(`${baseUrl}/dcwjTask/submitCrmDcwjTask`, data);
  },
  //医生联盟调查问卷-任务分配列表
  doctorDcwjTaskList(data) {
    return request.post(`${baseUrl}/dcwjTask/doctorDcwjTaskList`, data);
  },
  // 新 医生联盟调查问卷-任务分配列表
  doctorDcwjTaskListNew(data) {
    return request.post(`${baseUrl}/dcwjTask/doctorDcwjTaskListNew`, data);
  },
  //医生联盟调查问卷任务列表
  QuestionnaireList(data) {
    return request.post(`${baseUrl}/DoctorQuestion/QuestionnaireList`, data);
  },
  //医生联盟调查问卷-编辑接口
  adddoctorQuestionService(data) {
    return request.post(
      `${baseUrl}/DoctorQuestion/adddoctorQuestionService`,
      data
    );
  },
  //医生联盟调查问卷任务列表-点击编辑
  loaddoctorQuestionService(data) {
    return request.post(
      `${baseUrl}/DoctorQuestion/loaddoctorQuestionService`,
      data
    );
  },
  //医生联盟调查问卷-任务分配列表-提交
  submitDoctorDcwjTask(data) {
    return request.post(`${baseUrl}/dcwjTask/submitDoctorDcwjTask`, data);
  },
  // 导入 医生汇联盟
  importDcwjProjectData: `${baseUrl}/bingliProject/importDcwjProjectData`,
  // 导入 医学助手联盟
  importDcwjData: `${baseUrl}/projectTask/importDcwjData`
};
// 首页九宫格
export const projectIndex = data =>
  request.post(`${baseUrl}/projectIndex/index`, data);
// 新版项目
export const projectV2 = {
  //科室要求列表查询
  queryLimitDeptList(data) {
    return request.post(`${baseUrl}/projectV2/queryLimitDeptList`, data);
  },
  //科室要求保存
  saveLimitDeptList(data) {
    return request.post(`${baseUrl}/projectV2/saveLimitDeptList`, data);
  },
  assignProjectPerm(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/assignProjectPerm`,
      data
    );
  },
  // 下拉子菜单
  subAccountSelectOptions(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/querySubAccount`,
      data
    );
    // return request.get(
    //   'http://yapi.jimijiayuan.cn/mock/657/rest/cso/saas/subaccountManagement/querySubAccount',
    //   data
    // );
  },
  //权限配置 子账号列表 http://yapi.jimijiayuan.cn/project/657/interface/api/19355
  subAccountManagement(data) {
    return request.post(`${baseUrl}/subaccountManagement/indexList`, data);
    // return request.get(
    //   'http://yapi.jimijiayuan.cn/mock/657/rest/cso/saas/subaccountManagement/indexList',
    //   data
    // );
  },
  // 全部项目
  projectV2List(data) {
    return request.post(`${baseUrl}/projectV2/projectV2List`, data);
    // return request.get('http://yapi.jimijiayuan.cn/mock/657/fds', data);
  },
  // 获取下一个项目信息
  projectV2ListForEdit(data) {
    return request.post(`${baseUrl}/projectV2/projectV2ListForEdit`, data);
    // return request.get('http://yapi.jimijiayuan.cn/mock/657/fds', data);
  },
  //编辑项目-查看返回接口 http://yapi.jimijiayuan.cn/project/657/interface/api/9164
  loadProjectV2(data) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const res = await request.post(
          `${baseUrl}/projectV2/loadProjectV2`,
          data
        );

        const {
          tXcxProject: {
            taskValidDay,
            isUserEnterpriseRealName,
            isCPicRepeat,
            tmExecuteNameRule,
            tmTargetNameRule,
            szVisitType,
            tmQuesNameType,
            tmQuesNameRule,
            isTargetNameRule,
            isQuesNameRule
          }
        } = res.data.data;

        if (+tmQuesNameRule === 4 && +tmQuesNameType === 1) {
          console.log('错误数据处理');
          res.data.data.tXcxProject.tmQuesNameRule = 1;
        }
        if (tmQuesNameRule === null) {
          res.data.data.tXcxProject.tmQuesNameRule = 1;
        }
        if (tmQuesNameType === null) {
          res.data.data.tXcxProject.tmQuesNameType = 1;
        }

        if (taskValidDay == null) {
          res.data.data.tXcxProject.taskValidDay = 180;
        }
        if (isUserEnterpriseRealName == null) {
          res.data.data.tXcxProject.isUserEnterpriseRealName = 0; // 个体实名认证 默认 不需要：0 需要是 1
        }
        if (isCPicRepeat == null) {
          res.data.data.tXcxProject.isCPicRepeat = 0; // C端图片查重 默认 不需要：0 需要是 1
        }

        // 项目执行人脱敏规则
        if (+tmExecuteNameRule === 0) {
          res.data.data.tXcxProject.tmExecuteNameRule = 1; // 项目执行人 脱敏规则 默认为 部分隐藏
        }

        // 目标脱敏规则
        if (+isTargetNameRule !== 0 && +tmTargetNameRule === 0) {
          // 如果是患者
          if (+isTargetNameRule === 2 || +szVisitType === 13) {
            res.data.data.tXcxProject.tmTargetNameRule = 4; // 不处理
          } else {
            res.data.data.tXcxProject.tmTargetNameRule = 1; // 部分隐藏
          }
        }

        // 姓名题语言类型
        if (+isQuesNameRule === 0) {
          res.data.data.tXcxProject.tmQuesNameType = 0; // 默认语言类型 中文
          res.data.data.tXcxProject.tmQuesNameRule = 0; //默认 部分隐藏
        }
        resolve(res);
      } catch (err) {
        reject(err);
      }
    });
  },
  // 新增/编辑
  addUpdateProjectV2(data) {
    return request.post(`${baseUrl}/projectV2/addUpdateProjectV2`, data);
  },
  // 修改项目描述
  introductionEdit(data) {
    return request.post(`${baseUrl}/projectV2/introductionEdit`, data);
  },
  isNeedSign(data) {
    // 子账号 不掉真实接口
    if (!store.getters.isMaster) {
      return new Promise(resolve => {
        resolve({
          status: 1,
          message: '操作成功',
          code: '1',
          data: {
            platFormConStatus: { contractName: '', isNeedSign: 0 },
            aspGysSigningConStatus: {
              contractName: '',
              isNeedSign: 0
            }
          }
        });
      });
    }
    return request.post(`${baseUrl}/projectV2/isNeedSign`, data);
  },
  isNeedMakeInvoice(data) {
    // if (!store.getters.isMaster) {
    //   return new Promise(resolve => {
    //     resolve({
    //       status: 1,
    //       message: '',
    //       code: '1',
    //       data: {
    //         data: {
    //           isNeedMakeInvoice: 0
    //         }
    //       }
    //     });
    //   });
    // }
    return request.post(`${baseUrl}/projectOrder/isNeedMakeInvoice`, data);
  },
  exportThreeLevelProjectPayListDetail: `${baseUrl}/projectOrder/exportThreeLevelProjectPayListDetail`,

  submitProjectAudit(data) {
    //项目提交审核
    return request.post(`${baseUrl}/projectV2/submitProjectAudit`, data);
  },
  judgeProjectAudit(data) {
    //判断审核是否通过
    return request.post(`${baseUrl}/projectV2/judgeProjectAudit`, data);
  },

  obtainIndustryEnterprise(data) {
    //上游企业列表
    return request.post(`${baseUrl}/projectV2/obtainIndustryEnterprise`, data);
  },
  demandProjectList(data) {
    //服务项/子项
    return request.post(`${baseUrl}/projectV2/demandProjectList`, data);
  },
  // 根据项目id获取项目详情
  getServiceSubitemByProjectId(data) {
    return request.post(
      `${baseUrl}/projectV2/getServiceSubitemByProjectId`,
      data
    );
  },
  // 数字问卷项目是否配置专区和答题方式
  numberQuestionInfoByProject(data) {
    return request.post(
      `${baseUrl}/projectV2/numberQuestionInfoByProject`,
      data
    );
  }
};
export const signHTThree = {
  //静默签约功能
  closeSilentGrant() {
    //关闭合同静默签约权限、静默--->手动
    return request.get(`${baseUrl}/signHTThree/closeSilentGrant`);
  },
  openSilentGrant() {
    //开通合同静默签约权限、手动--->静默
    return request.get(`${baseUrl}/signHTThree/openSilentGrant`);
  },
  querySilentGrant() {
    //查询乙方是否开通静默签约权限
    return request.get(`${baseUrl}/signHTThree/querySilentGrant`);
  },
  signAllianceUserContract(data) {
    return request.get(`${baseUrl}/signHTThree/signAllianceUserContract`, {
      params: data
    });
  }
};
export const moreAuditQuestionnaireAnswer = data =>
  request.post(`${baseUrl}/questionnaire/moreAuditQuestionnaireAnswer`, data);
// 批量审核
export const addUpdateQuestionnaire = data =>
  request.post(`${baseUrl}/questionnaire/addUpdateQuestionnaire`, data);
// 调研问卷详情
export const questionnaireData = data =>
  request.post(`${baseUrl}/questionnaire/questionnaireData`, data);
// 导入问卷模板
export const questionnaireDataExport = `${baseUrl}/questionnaire/questionnaireDataExport`;
// 任务记录列表
export const questionnaireAnswerList = data =>
  request.post(`${baseUrl}/questionnaire/questionnaireAnswerList`, data);
// 问卷场景任务记录_图片是否重复
export const questionnaireAnswerListPicRepeat = data =>
  request.post(
    `${baseUrl}/questionnaire/questionnaireAnswerListPicRepeat`,
    data
  );
// 任务记录列表-审核
export const auditQuestionnaireAnswer = data =>
  request.post(`${baseUrl}/questionnaire/auditQuestionnaireAnswer`, data);
// 任务记录列表导出
export const exportQuestionnaireData = `${baseUrl}/questionnaire/exportQuestionnaireData`;
// 任务答题详情
export const questionnaireAnswerDetail = data =>
  request.post(`${baseUrl}/questionnaire/questionnaireAnswerDetail`, data);

/////////////////////////////////////////////////////线上推广/////////////////////////////////////////////////////////////////////
// 加载专区项目 参数 id
export const loadChannelProject = data =>
  request.post(`${baseUrl}/project/loadChannelProject`, data);
// 修改专区项目  price  乙方cso价格 ，  id   ，bgUrl 封面图
export const updateChannelProject = data =>
  request.post(`${baseUrl}/project/updateChannelProject`, data);
// 月度任务记录详情 month  projectId  userId
export const selectMonthTask = data =>
  request.post(`${baseUrl}/channel/selectMonthTask`, data);
// 任务记录 fullName 参与人名称 pageNo   pageSize    projectId 项目id  taskDt  时间
export const recordList = data =>
  request.post(`${baseUrl}/channel/recordList`, data);
//   汇总
export const recordSummaryList = data =>
  request.post(`${baseUrl}/channel/recordSummaryList`, data);
//   导出完整报表
export const exportUserHgtgExcel = `${baseUrl}/export/exportUserHgtgExcel`;
//   任务记录 导出甲
export const exportFirstHgtgExcel = `${baseUrl}/export/exportFirstHgtgExcel`;
//   任务记录 导出乙
export const exportSecondHgtgExcel = `${baseUrl}/export/exportSecondHgtgExcel`;
// 项目撤销列表
export const projectRevokeList = data =>
  request.post(`${baseUrl}/projectRevoke/list`, data);
// 撤销 id      authStatus 3 不通过 2 通过
export const authRevoke = data =>
  request.post(`${baseUrl}/projectRevoke/authRevoke`, data);

// 市场准入接口
export const access = {
  list(data) {
    //任务记录 市场准入（三级、零售、基层、三甲、二级）
    return request.post(`${baseUrl}/marketAccess/taskRecordlist`, data);
    // return request.get(
    //   'http://yapi.jimijiayuan.cn/mock/657/marketAccess/taskRecordlist',
    //   data
    // );
  },
  pageList(data) {
    //任务汇总
    return request.post(`${baseUrl}/marketAccess/pageList`, data);
  },
  pass(data) {
    return request.post(`${baseUrl}/marketAccess/updatePassStatus`, data);
  },
  exportExcelData: `${baseUrl}/marketAccess/exportMarketAccess`, // 导出
  exportMarketAccess: `${baseUrl}/marketAccess/exportMarketAccess`,
  exportExcelSumData: `${baseUrl}/marketAccess/exportMarketAccessTaskSummary` // 导出
};
/////////////////////////////////////////////////////我的订单/////////////////////////////////////////////////////////////////////
// 我的订单-(待支付/已支付)  hasPay 0:待支付订单/部分支付订单    1:已支付订单
export const projectOrderList = data =>
  request.post(`${baseUrl}/projectOrder/projectOrderList`, data);
// 校验所选择项目费用是否可勾选
export const checkOrderPay = data =>
  request.post(`${baseUrl}/csoCustomerOrder/checkOrderPay`, data);
// 判断订单支付渠道
export const checkPayBank = data =>
  request.post(`${baseUrl}/csoCustomerOrder/checkPayBank`, data);
// 项目支付详情
export const projectPayDetail = data =>
  request.post(`${baseUrl}/projectOrder/projectPayDetail`, data);
// 重新生成订单
export const regenerateCsoOrder = data =>
  request.post(`${baseUrl}/projectOrder/regenerateCsoOrder`, data);
// 终端结算详情
export const projectPayPeopleDetail = data =>
  request.post(`${baseUrl}/projectOrder/projectPayPeopleDetail`, data);
// 平台服务费详情
export const platformServicesDetail = data =>
  request.post(`${baseUrl}/projectOrder/platformServicesDetail`, data);
// 加载单条未完全支付订单
export const loadCsoOrder = data =>
  request.post(`${baseUrl}/projectOrder/loadCsoOrder`, data);
//单独支付服务费
export const payPlatformService = data =>
  request.post(`${baseUrl}/projectOrder/payPlatformService`, data);
// 支付订单发送短信
export const sendOrderPayMsg = data =>
  request.post(`${baseUrl}/projectOrder/sendOrderPayMsg`, data);
// 提交支付订单
export const submitPayOrder = data =>
  request.post(`${baseUrl}/projectOrder/submitPayOrder`, data);
// 支付账户信息
export const bfAccount = data =>
  request.post(`${baseUrl}/projectOrder/bfAccount`, data);
// 我的订单-已支付信息
export const projectOrderCompleteList = data =>
  request.post(`${baseUrl}/projectOrder/projectOrderCompleteList`, data);
//三级个人/三级个体 ASP订单  --项目支付详情
export const threeLevelProjectPayList = data =>
  request.post(`${baseUrl}/projectOrder/threeLevelProjectPayList`, data);
//加载单条未完全支付订单(三级个人或个体)
export const threeLevelloadCsoOrder = data =>
  request.post(`${baseUrl}/projectOrder/threeLevelLoadCsoOrder`, data);
// 结算中心-公司信息/账户余额/我的订单
export const indexInfo = data =>
  request.post(`${baseUrl}/accountsCenter/indexInfo`, data);
// 结算中心-账户余额，异常金额显示为0
export const getBalance = data =>
  request.post(`${baseUrl}/accountsCenter/getBalance`, data);
export const contractFourLevelFadanList = data =>
  request.post(
    `${baseUrl}/contractInformation/contractFourLevelFadanList`,
    data
  );
// 结算中心-收支统计
export const inOutInfo = data =>
  request.post(`${baseUrl}/accountsCenter/inOutInfo`, data);

// 结算中心-富友开通按钮查询接口
export const fyInfo = data =>
  request.post(`${baseUrl}/accountsCenter/fyInfo`, data);

// 结算中心-本月项目完成情况
export const currMonthInfo = data =>
  request.post(`${baseUrl}/accountsCenter/currMonthInfo`, data);

//结算中心-本月项目完成情况-下拉列表
export const currMonthInfoProject = data =>
  request.post(`${baseUrl}/accountsCenter/currMonthInfoProject`, data);
//结算中心-已支付订单-电子回单下载

export const alreadyDownBack = `${baseUrl}/projectOrder/supplierPayOrderNoDownload`;
export const alreadyDownBack2 = `${baseUrl}/projectOrder/singlePayOrderNoDownload`;
//结算中心-已支付订单-平台回单下载
// 入参: Long orderServiceId(当然列表获取),   String projectName,   String taskDt（取当然列表的任务月度）
export const alreadyPlatDownBack = `${baseUrl}/projectOrder/servicesPayOrderNoDownload`;
//结算中心-杂费管理-电子回单下载
export const otherDownBack = `${baseUrl}/otherCost/download`;
// 三级个人/三级个体/二级代开/二级个体 回单导出
export const threeLevelProjectPayListExportZip = data =>
  request.post(
    `${baseUrl}/projectOrder/threeLevelProjectPayListExportZip`,
    data
  );
// 三级灵工/三级汇总 回单导出
export const projectPayPeopleDetailExportZip = data =>
  request.post(`${baseUrl}/projectOrder/projectPayPeopleDetailExportZip`, data);
// 收支记录列表
export const payOutList = data =>
  request.post(`${baseUrl}/accountsCenter/payOutList`, data);
//失效订单
export const projectOrderInvalidList = data =>
  request.post(`${baseUrl}/projectOrder/projectOrderInvalidList`, data);
// 企业信息-发票信息
export const companyInfo = data =>
  request.post(`${baseUrl}/accountsCenter/companyInfo`, data);

//企业信息-保存发票信息
export const saveCompanyInfo = data =>
  request.post(`${baseUrl}/accountsCenter/saveCompanyInfo`, data);
//杂费管理
export const authOrderList = data =>
  request.post(`${baseUrl}/otherCost/authOrderList`, data);

//认证信息服务费详情
export const authOrderDetailList = data =>
  request.post(`${baseUrl}/otherCost/authOrderDetailList`, data);

//加载单条数据
export const loadAuthOrder = data =>
  request.post(`${baseUrl}/otherCost/loadAuthOrder`, data);

//杂费发送短信
export const otherSendOrderPayMsg = data =>
  request.post(`${baseUrl}/otherCost/sendOrderPayMsg`, data);

//支付操作
export const otherSubmitPayOrder = data =>
  request.post(`${baseUrl}/otherCost/submitPayOrder`, data);

export function submitTaskPrice(data) {
  return request.post(`${baseUrl}/projectTask/submitTaskPrice`, data);
}

export const comprehensive = {
  comprehensiveOrderList(data) {
    return request.post(
      `${baseUrl}/comprehensive/comprehensiveOrderList`,
      data
    );
  },
  comprehensivePeopleList(data) {
    return request.post(
      `${baseUrl}/comprehensive/comprehensivePeopleList`,
      data
    );
  },
  comprehensivePeopleProjectList(data) {
    return request.post(
      `${baseUrl}/comprehensive/comprehensivePeopleProjectList`,
      data
    );
  },
  comprehensivePeopleProjectList_Project(data) {
    return request.post(
      `${baseUrl}/comprehensive/comprehensivePeopleProjectList_Project`,
      data
    );
  },
  comprehensivePeopleProjectList_Yishou(data) {
    return request.post(
      `${baseUrl}/comprehensive/comprehensivePeopleProjectList_Yishou`,
      data
    );
  },
  loadComprehensiveOrder(data) {
    return request.post(
      `${baseUrl}/comprehensive/loadComprehensiveOrder`,
      data
    );
  },
  sendComprehensiveOrderPayMsg(data) {
    return request.post(
      `${baseUrl}/comprehensive/sendComprehensiveOrderPayMsg`,
      data
    );
  },
  submitComprehensivePayOrder(data) {
    return request.post(
      `${baseUrl}/comprehensive/submitComprehensivePayOrder`,
      data
    );
  },
  downloadComprehensiveReceipt: `${baseUrl}/comprehensive/downloadComprehensiveReceipt`
};
export const digital = {
  //数字拜访
  updateNumberVisitProject(data) {
    return request.post(
      `${baseUrl}/numberVisit/updateNumberVisitProject`,
      data
    );
  },
  numbervisitRecordList(data) {
    return request.post(`${baseUrl}/numberVisit/numbervisitRecordList`, data);
  },
  loadNumbervisitRecord(data) {
    return request.post(`${baseUrl}/numberVisit/loadNumbervisitRecord`, data);
  },
  auditNumberVisit(data) {
    return request.post(`${baseUrl}/numberVisit/auditNumberVisit`, data);
  },
  loadProjectV2_NumberVisit(data) {
    return request.post(
      `${baseUrl}/numberVisit/loadProjectV2_NumberVisit`,
      data
    );
  },
  numberVisitType(data) {
    return request.post(`${baseUrl}/numberVisit/numberVisitType`, data);
  },
  exportExcelData: `${baseUrl}/numberVisit/exportNumbervisitRecord`
};
export const merge = {
  mergeProjectOrder(data) {
    return request.post(
      `${baseUrl}/mergeProjectOrder/mergeProjectOrderList`,
      data
    );
  },
  mergeLoadCsoOrder(data) {
    return request.post(`${baseUrl}/mergeProjectOrder/mergeLoadCsoOrder`, data);
  },
  mergeLoadCsoOrderFee(data) {
    return request.post(
      `${baseUrl}/platformServiceFee/mergeLoadCsoOrderFee`,
      data
    );
  },
  mergeSendOrderPayMsg(data) {
    return request.post(
      `${baseUrl}/mergeProjectOrder/mergeSendOrderPayMsg`,
      data
    );
  },
  mergeSubmitPayOrder(data) {
    return request.post(
      `${baseUrl}/mergeProjectOrder/mergeSubmitPayOrder`,
      data
    );
  },
  mergeThreeLevelLoadCsoOrder(data) {
    return request.post(
      `${baseUrl}/mergeProjectOrder/mergeThreeLevelLoadCsoOrder`,
      data
    );
  },
  mergeThreeLevelLoadCsoOrderFee(data) {
    return request.post(
      `${baseUrl}/platformServiceFee/mergeThreeLevelLoadCsoOrderFee`,
      data
    );
  }
};
/****************************************************BI报表****************************************************************/

export const BI = {
  // 通用接口
  common: {
    // 查询项目基础信息-报表头部显示
    queryProjectBaseInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryProjectBaseInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 上传文件
    fileUpload(data) {
      return request.post(`${baseUrl}/upload/fileUploadProjectBI`, data);
    }, // 下载
    addPdf2TaskDownload(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/addPdf2TaskDownload`,
        data
      );
    }, // 下载
    addPdfOrPng2TaskDownload(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/addPdfOrPng2TaskDownload`,
        data
      );
    }
  },
  // 问卷
  dcwj: {
    // 问卷题型
    queryQuestionnaireDetailInfo(data) {
      return request.post(
        `${baseUrl}/bi/dcwjController/queryQuestionnaireDetailInfo`,
        data
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return request.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    }
  },
  // 可配置场景
  makeScene: {
    // 问卷题型
    queryQuestionnaireDetailInfo(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireDetailInfo`,
        data
      );
    },
    // 可配置场景目标题型
    queryQuestionnaireTargetDetailInfo(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireTargetDetailInfo`,
        data
      );
    },
    // 可配置场景时间题型
    queryQuestionnaireTimeTargetDetailInfo(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireTimeTargetDetailInfo`,
        data
      );
    },
    // 可配置场景定位题型
    queryQuestionnaireAddressTargetDetailInfo(data) {
      return request.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireAddressTargetDetailInfo`,
        data
      );
    },
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return request.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    }
  },
  jcyljg: {
    // 查询客户反馈统计信息
    queryCustomerFeedBack(data) {
      return request.post(
        `${baseUrl}/bi/jcyljgController/queryCustomerFeedBack`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询医院分类统计信息
    queryHospitalCategoryInfo(data) {
      return request.post(
        `${baseUrl}/bi/jcyljgController/queryHospitalCategoryInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询拜访时长统计信息
    queryVisitMinuteInfo(data) {
      return request.post(
        `${baseUrl}/bi/jcyljgController/queryVisitMinuteInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询拜访时间统计信息
    queryVisitTimeInfo(data) {
      return request.post(
        `${baseUrl}/bi/jcyljgController/queryVisitTimeInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return request.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 照片墙
    querytaskImgs(data) {
      return request.post(`${baseUrl}/bi/jcyljgController/querytaskImgs`, data);
    }
  },
  otc: {
    // 查询客户陈列状态 库存，是否有Pop，店员是知晓Pop 等信息
    queryOtcCustomerProductInfo(data) {
      return request.post(
        `${baseUrl}/bi/otcController/queryOtcCustomerProductInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询产品价格信息
    queryOtcProductPriceInfo(data) {
      return request.post(
        `${baseUrl}/bi/otcController/queryOtcProductPriceInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return request.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询巡店时间信息，按日，按小时统计
    queryOtcVisitTimeInfo(data) {
      return request.post(
        `${baseUrl}/bi/otcController/queryOtcVisitTimeInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 照片墙
    querytaskImgs(data) {
      return request.post(`${baseUrl}/bi/otcController/querytaskImgs`, data);
    },
    // 照片墙
    queryOtcTaskLocationInfo(data) {
      return request.post(
        `${baseUrl}/bi/otcController/queryOtcTaskLocationInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }
  },
  gradeHospital: {
    // 任务审核状态接口
    querytaskStatusTotalInfo(data) {
      return request.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryAllianceUserInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 项目参与人执行任务表
    queryTaskSumTotalInfo(data) {
      return request.post(`${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询项目下拜访医院分布
    querytaskHospitalDistribution(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访医院的照片
    querytaskImgs(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskImgs`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下医院等级分布
    querytaskHospitalGradeDistribution(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalGradeDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下科室分布
    querytaskDepartmentDistribution(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskDepartmentDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下医院职称分布
    querytaskHospitalTitleDistribution(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalTitleDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访时间
    querytaskVisitingTime(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskVisitingTime`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访时长
    querytaskLengthVisit(data) {
      return request.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskLengthVisit`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }
  }
};
export const BIv2 = {
  saveBiInfo(data) {
    return request.post(`${baseUrl}/v2/bi/biVisit/saveBiInfo`, data);
  },
  getBiModuleByBiId(data) {
    return request.post(`${baseUrl}/v2/bi/biVisit/getBiModuleByBiId`, data);
  },
  updateBiModuleById(data) {
    return request.post(`${baseUrl}/v2/bi/biVisit/updateBiModuleById`, data);
  }
};
/****************************************************批量审核****************************************************************/
export const batchAuditApi = {
  // 数字拜访
  batchAuditNumberVisit(data) {
    return request.post(`${baseUrl}/taskAudit/batchAuditNumberVisit`, data);
  },
  // 助手病例
  authBingliNew18(data) {
    return request.post(`${baseUrl}/taskAudit/authBingliNew18`, data);
  },
  // 医生汇病
  authDocBingli(data) {
    return request.post(`${baseUrl}/taskAudit/authDocBingli`, data);
  },
  // 拜访类型  1学术拜访  2 OTC  3 科室会  4 患教会  9 等级医院拜访  10基层医疗机构拜访  11 特级三甲医院市场准入 12 三级医院市场准入  13 二级医院市场准入  14 基层医疗机构市场准入 15 零售药店市场准入',
  updateUserVisitPlanAuditStatus(data) {
    return request.post(
      `${baseUrl}/taskAudit/updateUserVisitPlanAuditStatus`,
      data
    );
  }
};

///////////////////////////////////////////////税务申报////////////////////////////////////////////////////
export const taxDeclaration = {
  /**
   * 下拉客户企业
   * @param {}
   */
  firstEnterpriseList(data) {
    return request.post(`${baseUrl}/firstEnterprise/firstEnterpriseList`, data);
  },

  /**
   * 二级灵工服 薪未来(ASP)-C 导出稅收完税报表
   */
  taxPaymentReportSecondLevel: `${baseUrl}/firstEnterprise/taxPaymentReportSecondLevel`,

  /**
   * 二级灵工服 薪未来(ASP)-C 导出委托代征报表
   */
  taxEntrustPaymentReport: `${baseUrl}/firstEnterprise/taxEntrustPaymentReport`,

  /**
   * 三级灵工服 工业-薪未来(ASP)-C 导出稅收完税报表
   */
  taxPaymentReportThreeLevels: `${baseUrl}/firstEnterprise/taxPaymentReportThreeLevels`,

  /**
   * 三级灵工服 工业-薪未来(ASP)-C 导出委托代征报表
   */
  taxEntrustPaymentReportThreeLevels: `${baseUrl}/firstEnterprise/taxEntrustPaymentReportThreeLevels`
};

///////////////////////////////////////////////自然人信息管理////////////////////////////////////////////////////
export const naturalPersonInfoController = {
  /**
   * 获取当前乙方上游企业列表
   * @param {}
   */
  getIndustryEnterprise(data) {
    return request.post(
      `${baseUrl}/naturalPersonInfoController/getIndustryEnterprise`,
      data
    );
  },
  /**
   * 获取当前乙方下项目名称
   * @param {}
   */
  getProjects(data) {
    return request.post(
      `${baseUrl}/naturalPersonInfoController/getProjects`,
      data
    );
  },
  /**
   * 获取当前乙方下供应商名称
   * @param {}
   */
  getSuppliers(data) {
    return request.post(
      `${baseUrl}/naturalPersonInfoController/getSuppliers`,
      data
    );
  },

  /**
   * 乙方自然人信息管理-->自然人
   * @param {}
   */
  getInformationManagementUserType1(data) {
    return request.post(
      `${baseUrl}/naturalPersonInfoController/getUserInformationManagement`,
      data
    );
  },
  /**
   * 乙方自然人信息管理-->个体
   * @param {}
   */
  getInformationManagementUserType2(data) {
    return request.post(
      `${baseUrl}/naturalPersonInfoController/getUserInformationManagement`,
      data
    );
  }
};

///////////////////////////////////////////////可配置场景模板管理////////////////////////////////////////////////////
export const makeScene = {
  /**
   * 获取场景模板基础和风控题和内容题
   * @param {}
   */
  makeSceneInfoByProject(data) {
    return request.post(`${baseUrl}/makeScene/makeSceneInfoByProject`, data);
  },
  /**
   * 更新场景模板基础和风控题和内容题
   * @param {}
   */
  updateMakeSceneInfo(data) {
    return request.post(`${baseUrl}/makeScene/updateMakeSceneInfo`, data);
  },
  /**
   * 可配置场景任务审核
   * @param {}
   */
  batchAuditMakeScene(data) {
    return request.post(`${baseUrl}/makeSceneTask/batchAuditMakeScene`, data);
  },
  /**
   * 任务记录
   * @param {}
   */
  taskRecordMakeSceneList(data) {
    return request.post(
      `${baseUrl}/makeSceneTask/taskRecordMakeSceneList`,
      data
    );
  },
  /**
   * 任务记录
   * @param {}
   */
  taskRecordMakeSceneListPicRepeat(data) {
    return request.post(
      `${baseUrl}/makeSceneTask/taskRecordMakeSceneListPicRepeat`,
      data
    );
  },
  /**
   * 任务记录详情
   */
  makeSceneDetail(data) {
    return request.post(`${baseUrl}/makeSceneTask/makeSceneDetail`, data);
  },
  /**
   * 任务汇总
   */
  listMakeSceneTotal(data) {
    return request.post(`${baseUrl}/makeSceneTask/listMakeSceneTotal`, data);
  },
  // 任务汇总导出
  exportMakeSceneTotal: `${baseUrl}/makeSceneTask/exportMakeSceneTotal`,
  makeSceneDetailExport: `${baseUrl}/makeSceneTask/makeSceneDetailExport`
};
/****************************************************充值记录****************************************************************/
// 列表
export const rechargeRecordList = data =>
  request.post(`${baseUrl}/openAccount/rechargeRecordList`, data);
/****************************************************下载中心****************************************************************/
// 下载中心列表
export const taskDownloadList = async data => {
  // 改造接口
  const resp = await request.post(`${baseUrl}/download/taskDownloadList`, data);
  const {
    pdata: { list }
  } = resp;
  list.forEach(item => {
    // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
    if (!item.taskRecordUrls) {
      // 所有资源都是downloadUrl，没有taskRecordUrl
      if (item.downloadUrl) {
        item.taskRecordUrls = [
          {
            downloadName: item.downloadName,
            downloadUrl: item.downloadUrl,
            fileSize: item.fileSize,
            urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
          }
        ];
      } else {
        item.taskRecordUrls = [];
      }
    }
  });
  return resp;
};
/****************************************************搜索专区****************************************************************/
export const selectChannel = data =>
  request.post(`${baseUrl}/channelProject/selectChannel`, data);
/****************************************************项目内人员管理****************************************************************/
export const projectPersonnelManagement = {
  queryCertificationListAll(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/queryCertificationListAll`,
      data
    );
  },
  //项目人员列表
  // FIXME
  projectStaffList(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/projectStaffList`,
      data,
      {
        // yapi: ' 657'
      }
    );
  },
  //名单库添加列表
  panelLibraryAddsAList(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/panelLibraryAddsAList`,
      data
    );
  },
  //名单库添加
  savePanelLibraryAddsAList(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/savePanelLibraryAddsAList`,
      data,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        notUseQs: true
      }
    );
  },
  //人员名单次月邀请按钮
  saveInvite(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/saveInvite`,
      data
    );
  },
  //查看人员名单列表
  personnelList(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/personnelListNew`,
      data,
      {
        // yapi: '657'
      }
    );
  },
  //项目-人员-单独添加
  addedIndividually(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/addedIndividually`,
      data
    );
  },
  // 人员名单列表全选
  panelLibraryAddsAListCheckAll(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/panelLibraryAddsAListCheckAll`,
      data
    );
  },
  // 修改任务量
  taskNumAlter(data) {
    return request.post(`${baseUrl}/importInAdvance/taskNumAlter`, data);
  },
  // 获取已有任务量
  userTaskNum(data) {
    return request.post(`${baseUrl}/importInAdvance/userTaskNum`, data);
  },
  // 批量不邀请
  bulkImportsAreNotInvited: `${baseUrl}/downLoadTemplate/bulkImportsAreNotInvited`,
  // 上传项目人员名单
  importUserOrTask: `${baseUrl}/importInAdvance/importUserOrTask`,
  // 是否有新的撤销数据
  getNewestUserTaskRevoke(data) {
    return request.post(`${baseUrl}/projectV2/getNewestUserTaskRevoke`, data);
  },
  // 任务撤回列表
  getUserTaskRevokeList(data) {
    return request.post(`${baseUrl}/projectV2/getUserTaskRevokeList`, data);
  },
  // 获取项目人员全部邀请状态
  projectInfo(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/projectInfo`,
      data
    );
  },
  // 设置项目人员全部邀请状态
  projectStatus(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/projectStatus`,
      data
    );
  },
  // 人员标签下拉列表
  listPersonTagForSelect(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/listPersonTagForSelect`,
      data
    );
  },
  // 其他项目人员标签下拉列表
  listPersonTagForSelectWithLibrary(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/listPersonTagForSelectWithLibrary`,
      data
    );
  },
  // 修改人员标签
  modifyUserTag(data) {
    return request.post(
      `${baseUrl}/ProjectPersonnelManagement/modifyUserTag`,
      data
    );
  },
  // 检查上传文件中多少标签为空
  checkProjectTaskPlanExcel(data) {
    return request.post(
      `${baseUrl}/importInAdvance/checkProjectTaskPlanExcel`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
  },
  // 更新人员标签填写提示
  updateSkip(data) {
    return request.post(`${baseUrl}/importInAdvance/updateSkip`, data);
  }
};
/****************************************************项目人员管理-下载****************************************************************/

export const downLoadTemplate = {
  //项目人员列表
  downloadFile(data, isUrl) {
    if (isUrl) {
      return `${baseUrl}/downLoadTemplate/downloadFile`;
    }
    return request.get(`${baseUrl}/downLoadTemplate/downloadFile`, {
      params: data
    });
  },
  //批量不邀请模板下载
  batchNoInvitationDownLoad(data, isUrl) {
    if (isUrl) {
      return `${baseUrl}/downLoadTemplate/batchNoInvitationDownLoad`;
    }
    return request.get(
      `${baseUrl}/downLoadTemplate/batchNoInvitationDownLoad`,
      { params: data }
    );
  },
  //人员名单模板下载
  personnelDownLoad(data, isUrl) {
    if (isUrl) {
      return `${baseUrl}/downLoadTemplate/personnelDownLoad`;
    }
    return request.get(`${baseUrl}/downLoadTemplate/personnelDownLoad`, {
      params: data
    });
  },
  //名单下载
  downloadTheList(data, isUrl) {
    if (isUrl) {
      return `${baseUrl}/downLoadTemplate/downloadTheList`;
    }
    return request.get(`${baseUrl}/downLoadTemplate/downloadTheList`, {
      params: data
    });
  }
};
/****************************************************项目人员管理(外模块)****************************************************************/
export const agentManager = {
  updateOrMergeUserPhone(data) {
    return request.post(`${baseUrl}/agentManager/updateOrMergeUserPhone`, data);
  },
  // 乙方用工人员（个体）列表
  agentList(data) {
    return request.post(`${baseUrl}/agentManager/agentList`, data);
  },
  // 添加人员（个体）
  agentAdd(data) {
    return request.post(`${baseUrl}/agentManager/agentAdd`, data);
  },
  // 批量添加人员（个体）
  agentsBatchAdd(data) {
    return request.post(`${baseUrl}/agentManager/agentsBatchAdd`, data);
  },
  // 历史参与项目
  projectInfoJoined(data) {
    return request.post(`${baseUrl}/agentManager/projectInfoJoined`, data);
  },
  // 本月项目下拉框
  projectInfoSuitable(data) {
    return request.post(`${baseUrl}/agentManager/projectInfoSuitable`, data);
  },
  // 工业下拉列表
  listGongyeWithProjectUserForSelect(data) {
    return request.post(
      `${baseUrl}/agentManager/listGongyeWithProjectUserForSelect`,
      data
    );
  },
  // 项目人员管理列表_预计结算服务总价
  agentListAmount(data) {
    return request.post(`${baseUrl}/agentManager/agentListAmount`, data);
  },
  // 项目人员管理列表_参与项目详情
  listProjectUserDetail(data) {
    return request.post(`${baseUrl}/agentManager/listProjectUserDetail`, data);
  },
  // 本月参与项目
  projectInfoJoinedCurrentMonth(data) {
    return request.post(
      `${baseUrl}/agentManager/projectInfoJoinedCurrentMonth`,
      data
    );
  },
  // 将个人或者个体添加进项目
  projectsJoin(data) {
    return request.post(`${baseUrl}/agentManager/projectsJoin`, data, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      notUseQs: true
    });
  },
  // 批量禁用
  agentBatchForbidden: `${baseUrl}/agentManager/agentBatchForbidden`,
  // 禁用/启用
  agentForbiddenOrActive(data) {
    return request.post(`${baseUrl}/agentManager/agentForbiddenOrActive`, data);
  },
  // 导出人员
  exportAgentList(data, isUrl) {
    if (isUrl) {
      return `${baseUrl}/agentManager/exportAgentList`;
    }
    return request.get(`${baseUrl}/agentManager/exportAgentList`, {
      params: data
    });
  },
  // 禁用/启用 -- 交付制
  operateUserProjectStatus(data) {
    return request.post(
      `${baseUrl}/agentManager/operateUserProjectStatus`,
      data
    );
  },
  // 一键开启或关闭
  openOrCloseUserProjectStatus(data) {
    return request.post(
      `${baseUrl}/agentManager/openOrCloseUserProjectStatus`,
      data
    );
  }
};

/****************************************************结算中心 start****************************************************************/
/**
 * @desc  多次结算=》我的订单=》订单管理 （server：用户订单） http://yapi.jimijiayuan.cn/project/657/interface/api/15731
 */
export const csoCustomerOrder = {
  checkOrderSign: data =>
    request.post(`${baseUrl}/myorder/checkOrderSign`, data),
  exportOrderNoSignPeople: `${baseUrl}/myorder/exportOrderNoSignPeople`,
  oneOrderPlatformServiceOrder: data =>
    request.post(
      `${baseUrl}/platformServiceOrder/oneOrderPlatformServiceOrder`,
      data
    ),
  oneOrderBusServiceOrder: data =>
    request.post(
      `${baseUrl}/platformServiceOrder/oneOrderBusServiceOrder`,
      data
    ),
  submitPayOrderV2: data =>
    request.post(`${baseUrl}/csoCustomerOrder/submitPayOrderV2`, data),
  sendOrderPayMsgV2: data =>
    request.post(`${baseUrl}/csoCustomerOrder/sendOrderPayMsgV2`, data),
  noPayOrder: data =>
    request.post(`${baseUrl}/csoCustomerOrder/noPayOrder/list`, data),
  needPayServicesPriceInfo: data =>
    request.post(`${baseUrl}/myorder/needPayServicesPriceInfo`, data),
  tipsPayServicesPriceInfo: data =>
    request.post(`${baseUrl}/myorder/tipsPayServicesPriceInfo`, data),
  queryPayOrderDetailAll: data =>
    request.post(`${baseUrl}/csoCustomerOrder/queryPayOrderDetailAll`, data),
  totalProjectByIds: data =>
    request.post(`${baseUrl}/csoCustomerOrder/totalProjectByIds`, data),
  payOrderMinInfo: data =>
    request.post(`${baseUrl}/myorder/payOrderMinInfo`, data),
  totalNoPayCsoCustomOrder_1614585024069: data =>
    request.post(
      `${baseUrl}/csoCustomerOrder/totalNoPayCsoCustomOrder_1614585024069`,
      data
    ),
  orderPeopleInfoBatchDownload: `${baseUrl}/csoCustomerOrder/orderPeopleInfoBatchDownload`,
  queryCustomOrderInfo: data =>
    request.post(
      `${baseUrl}/csoCustomerOrderStatistics/queryCustomOrderInfo`,
      data
    ),
  // 所有项目
  listAllProjectForSelect: data =>
    new Promise(resolve => {
      request
        .post(`${baseUrl}/csoCustomerOrder/listAllProjectForSelect`, data)
        .then(res => {
          let list = res.data.data;
          list = list.filter(i => i);
          res.data.data = uniqueByFieldName(list, 'project_id');
          resolve(res);
        });
    }),
  // 生成订单-任务月度下拉列表查询
  listAllTaskDtForSelect: data =>
    request.post(`${baseUrl}/csoCustomerOrder/listAllTaskDtForSelect`, data),

  // 所有人员列表
  listAllPeople: data =>
    new Promise(resolve => {
      request
        .post(`${baseUrl}/csoCustomerOrder/listAllPeople`, data)
        .then(res => {
          // 因为 数据可能出现 id 相同的情况 ，所以添加 自定义 超键 _superKey，用于多选
          let list = res.data.data.list;

          res.data.data.list = list.map(i => {
            let type = undefined;
            if (!i.projectStructureType) {
              type = '空';
            }
            if (i.projectStructureType === 1) {
              type = 4;
            }
            if (i.projectStructureType === 2 || i.projectStructureType === 3) {
              type = 3;
            }
            return { ...i, _superKey: `${type}-${i.id}` };
          });

          resolve(res);
        });
    }),

  // 所有人员id
  selectAllPeople: data =>
    new Promise(resolve => {
      request
        .post(`${baseUrl}/csoCustomerOrder/selectAllPeople`, data)
        .then(res => {
          // 因为 数据可能出现 id 相同的情况 ，所以添加 自定义 超键 _superKey，用于多选
          // let type3 = JSON.parse(res.data.data.threeIds).map(i => ({ _superKey: `3-${i}` }));
          let type3 = JSON.parse(res.data.data.threeIds).map(i => ({
            _superKey: `3-${i}`
          }));
          let type4 = JSON.parse(res.data.data.fourIds).map(i => ({
            _superKey: `4-${i}`
          }));
          resolve({
            data: {
              data: [...type3, ...type4]
            }
          });
        });
    }),

  // 生成订单-根据数据id串查询（统计）出人员数据
  totalPeopleByIds: data =>
    request.post(`${baseUrl}/csoCustomerOrder/totalPeopleByIds`, data),

  // 生成订单-根据数据id串查询出人员数据
  listPeopleByIds: data =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async resolve => {
      let {
        data: { data: resp }
      } = await request.post(
        `${baseUrl}/csoCustomerOrder/listPeopleByIds`,
        data
      );
      let { list } = resp;
      let setNewType = projectStructureType => {
        let map = {
          1: 4,
          2: 3,
          3: 3
        };
        return map[projectStructureType] || '空';
      };
      list.forEach(item => {
        item._superKey = `${setNewType(item.projectStructureType)}-${item.id}`;
      });
      let result = {
        data: {
          data: resp
        }
      };
      resolve(result);
    }),

  // 项目结算管理 列表
  listProjectCheckManage: data =>
    request.post(`${baseUrl}/center/listProjectCheckManage`, data),

  // 项目结算管理 订单详情
  listOrderDetail(data) {
    return new Promise((resolve, reject) => {
      request
        .post(`${baseUrl}/center/listOrderDetail`, data)
        .then(res => {
          const {
            data: {
              data: { list }
            }
          } = res;
          const { structureType, projectName } = data;
          const respond = list.map(i => ({ ...i, structureType, projectName }));
          resolve({
            ...res,
            data: {
              data: {
                list: respond
              }
            }
          });
        })
        .catch(reject);
    });
  },

  // 项目结算管理 列表 支付进度列表
  listPaySchedule(data) {
    return new Promise(resolve => {
      // 项目名称 和 任务月度 由 项目结算管理 列表 传
      request.post(`${baseUrl}/center/listPaySchedule`, data).then(res => {
        let list = res.data.data.list;
        res.data.data.list = list.map(i => {
          const { structureType, taskDt, projectName } = data;
          return {
            ...i,
            structureType,
            taskDt,
            projectName
          };
        });
        resolve(res);
      });
    });
  },

  // 项目结算管理 详情 支付进度列表
  listOrderPaySchedule: data => {
    return new Promise((resolve, reject) => {
      request
        .post(`${baseUrl}/center/listOrderPaySchedule`, data)
        .then(res => {
          const {
            data: {
              data: { list }
            }
          } = res;
          const { projectName, structureType } = data;
          res.data.data.list = list.map(i => {
            return {
              ...i,
              projectName,
              structureType
            };
          });
          resolve(res);
        })
        .catch(reject);
    });
  },

  createOrderByIds(data) {
    return request.post(`${baseUrl}/csoCustomerOrder/createOrderByIds`, data, {
      btnLoading: true
    });
  },

  // 结算中心 订单管理 修改支付人列表
  listNoPayOrderPeopleByOrderId(data) {
    return request.post(
      `${baseUrl}/csoCustomerOrder/listNoPayOrderPeopleByOrderId`,
      data
    );
  },

  // 结算中心 订单管理 支付人 移除
  delNoPayOrderPeople: data => {
    return request.post(
      `${baseUrl}/csoCustomerOrder/delNoPayOrderPeople`,
      data
    );
  },
  // 项目管理_供应商列表
  listSuppliers: data => {
    return request.post(`${baseUrl}/center/listSuppliers`, data);
  },
  // 超额人员列表
  listOverrunQuotaOrderPeopleForCreate: data => {
    return request.post(
      `${baseUrl}/csoCustomerOrder/listOverrunQuotaOrderPeopleForCreate`,
      data
    );
  },
  // 未支付订单列表(按项目查询、按项目查询) tag 1-按批次查询(默认) 2-按项目查询
  unPayOrderList(data) {
    return request.post(`${baseUrl}/myorder/unPayOrderList`, data);
  },
  // 已支付订单列表(按项目查询、按项目查询) tag 1-按批次查询(默认) 2-按项目查询
  payOrderList(data) {
    return request.post(`${baseUrl}/myorder/payOrderList`, data);
  },
  // 待支付-批量-修改
  listPayOrderByBatchOrderId(data) {
    return request.post(
      `${baseUrl}/csoCustomerOrder/listPayOrderByBatchOrderId`,
      data
    );
  }
};
/****************************************************结算中心 ended****************************************************************/

/****************************************************订单管理 新****************************************************************/

// 判断是否可进行下一步操作
export const isContainRevokePeople = data =>
  request.post(`${baseUrl}/csoCustomerOrder/isContainRevokePeople`, data);
// 结算中心- 订单管理- 已支付订单批量下载和下载全部回单
export const listPayOrderExportZip = data =>
  request.post(`${baseUrl}/OrderExportZip/listPayOrderExportZip`, data);
// 结算中心- 订单管理- 已支付订单批量下载勾选回单
export const downloadBankPayUrl = data =>
  request.post(`${baseUrl}/OrderExportZip/downloadBankPayUrl`, data, {
    notUseQs: true,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  });
// 结算中心- 订单管理- 下载回单（直接下载）
export const payOrderExportZip = data =>
  request.post(`${baseUrl}/OrderExportZip/payOrderExportZip`, data);
// 结算中心- 订单管理- 已支付订单-打款总金额-下载全部回单
export const listPayOrderPeopleAndSupplieExportZip = data =>
  request.post(
    `${baseUrl}/OrderExportZip/listPayOrderPeopleAndSupplieExportZip`,
    data
  );
// 前往支付-查询已选择的待支付订单
export const listNoPayOrderByIds = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listNoPayOrderByIds`, data);
// 待支付相关页面的统计
export const totalNoPayCsoCustomOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/totalNoPayCsoCustomOrder`, data);
// 待支付打款总金额_统计
export const unPayStatisticsAmount = data =>
  request.post(`${baseUrl}/myorder/unPayStatisticsAmount`, data);
// 待支付打款总金额_列表
export const listPayOrderDetail = data =>
  request.post(`${baseUrl}/myorder/listPayOrderDetail`, data);
// 订单支付详情
export const queryPayOrderDetail = data =>
  request.post(`${baseUrl}/csoCustomerOrder/queryPayOrderDetail`, data);
// 支付确认-短信确认-发送短信
export const csoCustomerOrderSendOrderPayMsg = data =>
  request.post(`${baseUrl}/csoCustomerOrder/sendOrderPayMsg`, data);
// 本次打款总金额（待支付）...
export const listNoPayOrderPeopleAndSuppliePeopleAll = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listNoPayOrderPeopleAndSuppliePeopleAll`,
    data
  );
// 本次打款总金额（待支付）_统计...
export const totalNoPayOrderPeopleAndSuppliePeopleAll = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalNoPayOrderPeopleAndSuppliePeopleAll`,
    data
  );
// 本次打款总金额（部分支付成功）
export const listNoPayOrderPeopleAndSupplie = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listNoPayOrderPeopleAndSupplie`,
    data
  );
// 本次打款总金额_（部分支付成功）_统计
export const totalNoPayOrderPeopleAndSupplie = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalNoPayOrderPeopleAndSupplie`,
    data
  );
// 本次打款总金额_（部分支付成功）_结算总价
export const listNoPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listNoPayOrderPeopleAndSuppliePeople`,
    data
  );
// 本次打款总金额_（部分支付成功）_结算总价_统计
export const totalNoPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalNoPayOrderPeopleAndSuppliePeople`,
    data
  );
// 获取当前所有待支付
export const listNoPayOrderAll = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listNoPayOrderAll`, data);
// 获取当前所有待支付--新
export const listNoPayOrderAllV2 = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listNoPayOrderAllV2`, data);
// 提交支付
export const csoCustomerOrderSubmitPayOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/submitPayOrder`, data);

// 已支付订单列表查询
export const listPayOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listPayOrder`, data);
// 本次打款总金额
export const listPayOrderPeopleAndSupplie = data =>
  request.post(`${baseUrl}/myorder/listPayOrderPeopleAndSupplie`, data);
// 本次打款总金额_统计
export const totalPayOrderPeopleAndSupplie = data =>
  request.post(`${baseUrl}/myorder/totalPayOrderPeopleAndSupplie`, data);
// 本次打款总金额_统计_结算总价
export const listPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listPayOrderPeopleAndSuppliePeople`,
    data
  );
// 本次打款总金额_统计_结算总价_统计
export const totalPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalPayOrderPeopleAndSuppliePeople`,
    data
  );

// 已失效订单列表查询 -- 项目
export const listInvalidPayOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listInvalidPayOrder`, data);
// 已失效订单列表查询 -- 批次
export const listBatchInvalidPayOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/listBatchInvalidPayOrder`, data);
// 重新生成订单
export const rebuildPayOrder = data =>
  request.post(`${baseUrl}/csoCustomerOrder/rebuildPayOrder`, data);
// 全部重新生成订单
export const rebuildPayOrderAll = data =>
  request.post(`${baseUrl}/csoCustomerOrder/rebuildPayOrderAll`, data);
// 本次打款总金额
export const listInvalidPayOrderPeopleAndSupplie = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listInvalidPayOrderPeopleAndSupplie`,
    data
  );
// 本次打款总金额_统计
export const totalInvalidPayOrderPeopleAndSupplie = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalInvalidPayOrderPeopleAndSupplie`,
    data
  );
// 本次打款总金额_统计_结算总价
export const listInvalidPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listInvalidPayOrderPeopleAndSuppliePeople`,
    data
  );
// 本次打款总金额_统计_结算总价_统计
export const totalInvalidPayOrderPeopleAndSuppliePeople = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/totalInvalidPayOrderPeopleAndSuppliePeople`,
    data
  );
// 前往支付-判断限额
export const isOverrunQuota = (data, config = {}) =>
  request.post(`${baseUrl}/csoCustomerOrder/isOverrunQuota`, data, {
    ...config
  });
// 超额人员提示-列表查询-支付时调用
export const listOverrunQuotaOrderPeopleForPay = data =>
  request.post(
    `${baseUrl}/csoCustomerOrder/listOverrunQuotaOrderPeopleForPay`,
    data
  );
// 已支付页面---下载已支付订单的相关人员信息
export const orderPeopleInfoDownload = `${baseUrl}/csoCustomerOrder/orderPeopleInfoDownload`;

// 超额用户详情列表
export const overrunQuotaOrderPeopleList = data =>
  request.post(`${baseUrl}/csoCustomerOrder/overrunQuotaOrderPeopleList`, data);
/****************************************************服务费管理****************************************************************/
// 待支付订单列表查询
export const listNoPayPlatformServiceOrder = data =>
  request.post(
    `${baseUrl}/platformServiceOrder/listNoPayPlatformServiceOrder`,
    data
  );
// 订单详情查询
export const queryPlatformServiceOrderDetail = data =>
  request.post(
    `${baseUrl}/platformServiceOrder/queryPlatformServiceOrderDetail`,
    data
  );
// 已支付订单列表查询
export const listPayPlatformServiceOrder = data =>
  request.post(
    `${baseUrl}/platformServiceOrder/listPayPlatformServiceOrder`,
    data
  );
// 支付确认-短信确认-发送短信
export const platformServiceOrderSendOrderPayMsg = data =>
  request.post(`${baseUrl}/platformServiceOrder/sendOrderPayMsg`, data);
// 提交支付
export const platformServiceOrderSubmitPayOrder = data =>
  request.post(`${baseUrl}/platformServiceOrder/submitPayOrder`, data);

/****************************************************BI个人导出****************************************************************/
export const personalBI = {
  // 线上推广
  num6(data) {
    return request.post(`${baseUrl}/bi/downloadAcademicVisitBIZip/num6`, data);
  },
  // 数字拜访
  num17(data) {
    return request.post(`${baseUrl}/bi/downloadAcademicVisitBIZip/num17`, data);
  },
  // 协定服务乙方个人BI下载任务开始 19
  startAgreementServiceBiDownloadTask(data) {
    return request.post(
      `${baseUrl}/bitask/startAgreementServiceBiDownloadTask`,
      data
    );
  },
  // 1学术拜访  2 OTC  3 科室会  4 患教会  9 等级医院拜访  10基层医疗机构拜访 11 特级三甲医院市场准入  12 三级医院市场准入  13 二级医院市场准入  14 基层医疗机构市场准入 15 零售药店市场准入
  addVisitBIZipTask(data) {
    return request.post(`${baseUrl}/bi/addVisitBIZipTask`, data);
  },
  // 患者调研乙方个人BI下载任务开始
  hzdyAllYEport(data) {
    return request.post(`${baseUrl}/hzdYBIExprot/hzdyAllYEport`, data);
  },
  // 可配置场景乙方个人BI下载任务开始
  kpzAllYEport(data) {
    return request.post(`${baseUrl}/KpzBIExprot/kpzAllYEport`, data);
  },
  // 医生病历
  docBlAllEport(data) {
    return request.post(`${baseUrl}/docBingli/docBlAllEport`, data);
  },
  // 助手病例个人bi报表导出任务申请
  startCaseBiTask(data) {
    return request.post(`${baseUrl}/bitask/startCaseBiTask`, data);
  }
};
// 支付审核
export const paymentReview = {
  // 项目下拉
  listProjectName(data) {
    return request.post(`${baseUrl}/paymentReview/listProjectName`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 审核列表
  list(data) {
    return request.post(`${baseUrl}/paymentReview/list`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 检查是否需要展示tab栏
  check(data) {
    return request.post(`${baseUrl}/paymentReview/check`, data);
  },
  // 工业/供应商企业下拉
  listEnterpriseName(data) {
    return request.post(`${baseUrl}/paymentReview/listEnterpriseName`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 订单详情
  id(data) {
    return request.post(`${baseUrl}/paymentReview/id`, data);
  },
  // 订单审核
  audit(data) {
    return request.post(`${baseUrl}/paymentReview/audit`, data);
  }
};
/**************************************************** 分配任务量 ****************************************************************/
export const assignTask = {
  importTaskAuditStatus(params) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const {
        data: {
          data: { hasImport, applyInfo }
        }
      } = await request.post(
        `${baseUrl}/importInAdvance/importTaskAuditStatus`,
        params
      );
      const auditStatus = applyInfo && applyInfo['auditStatus'];
      if (hasImport !== null && +hasImport === 0) {
        resolve({ auditStatus: '0' });
      } else {
        resolve({ auditStatus: auditStatus + '', applyInfo });
      }
    });
  },
  importTaskAuditStatusVersion2(params) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const {
        data: { data }
      } = await request.post(
        `${baseUrl}/importInAdvance/importTaskAuditStatusVersion2`,
        params
      );
      resolve({
        auditStatus: `${(data || {}).auditStatus || 0}`,
        applyInfo: data || {}
      });
    });
  },
  // 获取目前修改任务量审核中的人员ID
  querAspImportTaskApplyUserIdList(params) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const {
        data: { data }
      } = await request.post(
        `${baseUrl}/importInAdvance/querAspImportTaskApplyUserIdList`,
        params
      );
      resolve(data);
    });
  },
  /**
   *
   * @param data
   * @return {Promise< String >}
   * @desc http://yapi.jimijiayuan.cn/project/657/interface/api/16351
   */
  getosscheckstatus(data) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const {
          data: {
            data: [obj]
          }
        } = await request.post(`${baseUrl}/common/getosscheckstatus`, data);
        resolve(obj || {});
      } catch (err) {
        reject(new Error('服务器错误' + err));
      }
    });
  }
};
/****************************************************退出结算****************************************************************/
// 退出结算审核的列表查询
export const listRevokeOrderPeople = data =>
  request.post(`${baseUrl}/revokeOrder/listRevokeOrderPeople`, data);
// 退出结算审核操作
export const auditRevokeOrderPeople = data =>
  request.post(`${baseUrl}/revokeOrder/auditRevokeOrderPeople`, data);

/****************************************************判断当前问卷重合度****************************************************************/
export const checkQuestionnaireIsAlikeAjax = data =>
  request.post(`${baseUrl}/warning/listReportWarningInfo`, data);
/****************************************************退出项目****************************************************************/
// 查询项目月度是否有用户退出并处于审核中状态
export const isExistUserOut = data =>
  request.post(`${baseUrl}/projectSettled/isExistUserOut`, data);

/**************************************************** 签约信息 ****************************************************************/
// 自然人 列表
export const signingInfoPersonList = data =>
  // request.post(`${'/signingInfo'}/person/list`,data,{yapi:'917'})
  request.post(`${baseUrl}/signingInfo/person/list`, data);
// 自然人 列表 合同详情（列表）
export const personContractList = data =>
  // request.post(`${'/signingInfo'}/person/contracts`,data,{yapi:'917'})
  request.post(`${baseUrl}/signingInfo/person/contracts`, data);

// 个体 列表
export const userEnterpriseList = data =>
  // request.post(`${'/signingInfo'}/person/list`,data,{yapi:'917'})
  request.post(`${baseUrl}/signingInfo/userEnterprise/list`, data);

// 个体 列表 导出
export const userEnterpriseListExport = data =>
  // request.post(`${'/signingInfo'}/person/list`,data,{yapi:'917'})
  request.post(`${baseUrl}/signingInfo/userEnterprise/list/export`, data);

/**************************************************** 电子合同 ****************************************************************/
//供应商合同列表
export const gysContractList = data =>
  // request.post(`${baseUrl}/contractV2/gysContractList`,data,{yapi:'917'})
  request.post(`${baseUrl}/contractV2/gysContractList`, data);

//供应商合同列表 下拉框
export const listPartyInfoForSelect = data =>
  // 接口地址：http://yapi.jimijiayuan.cn/project/917/interface/api/17311
  request.post(`${baseUrl}/contractV2/listPartyInfoForSelect`, data);

//电子结算单 下拉框
export const listPartyInfoForSelectTWO = data =>
  // 接口地址：http://yapi.jimijiayuan.cn/project/917/interface/api/17311
  request.post(`${baseUrl}/contractV2/listPartyInfoForSelectTWO`, data);

//自然人合同列表
export const naturalPersonalContractList = data =>
  request.post(`${baseUrl}/contractV2/naturalPersonalContractList`, data);
// 自然人合同批量下载
export const naturalPersonalContractBatchDownload = data =>
  request.post(
    `${baseUrl}/contractV2/naturalPersonalContractBatchDownload`,
    data
  );

//个体合同列表
export const userEnterpriseContractList = data =>
  request.post(`${baseUrl}/contractV2/userEnterpriseContractList`, data);
//个体合同批量下载
export const userEnterpriseContractBatchDownload = data =>
  request.post(
    `${baseUrl}/contractV2/userEnterpriseContractListBatchDownload`,
    data
  );
//个体合同列表 详情
export const signingInfoUserEnterpriseContracts = data =>
  request.post(`${baseUrl}/signingInfo/userEnterprise/contracts`, data);

//平台服务合同
export const platformContractList = data =>
  request.post(`${baseUrl}/contractV2/platformContractList`, data);

//电子结算单合同列表
export const dianziContractList = data =>
  request.post(`${baseUrl}/contractV2/dianziContractList`, data);
/****************************************************项目入驻****************************************************************/
// 自然人/个体-列表
export const projectSettledList = data =>
  request.post(`${baseUrl}/projectSettled/list`, data);
/****************************************************项目退出****************************************************************/
// 自然人/个体-列表
export const personSettledOutList = data =>
  request.post(`${baseUrl}/projectSettled/personSettledOutList`, data);
// 项目退出（通过/不通过）
export const projectSettledAuditSettledOut = data =>
  request.post(`${baseUrl}/projectSettled/auditSettledOut`, data);

/****************************************************登录验证****************************************************************/
export const checkVerification = data =>
  request.post(`${baseUrl}/check/verification/result`, data);

export const getVerification = data =>
  request.post(`${baseUrl}/get/verification/imageJson?type=slide`, data);

/****************************************************删除自然人****************************************************************/
export const delPersonnel = data =>
  // request.post(`${baseUrl}/ProjectPersonnelManagement/delPersonnel`, data);
  request.post(`${baseUrl}/ProjectPersonnelManagement/deleteUser`, data);

// 批量下载 收支记录
export const payOutVoucherDownload = data => {
  return request.get(`${baseUrl}/accountsCenter/payOutVoucherDownload`, {
    params: data
  });
};
// 导出 收支记录
export const exportPayOutList = data => {
  return request.get(`${baseUrl}/accountsCenter/exportPayOutList`, {
    params: data
  });
};
/****************************************************职业认证****************************************************************/
// 认证详情
export const certificationDetails = data => {
  return request.post(`${baseUrl}/vocational/certificationDetails`, data);
};

export const listRepeatPic = data => {
  return request.post(`${baseUrl}/taskRecordPic/listRepeatPic`, data);
};
/****************************************************项目BI****************************************************************/
export const biBase = {
  saveBiInfo: data => {
    return request.post(`${baseUrl}/bi/biVisit/saveBiInfo`, data, {
      // yapi: '657'
    });
  },
  getBiInfoUpdateStatus: data => {
    return request.post(`${baseUrl}/bi/biVisit/getBiInfoUpdateStatus`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  projectCurrent: data => {
    return request.post(`${baseUrl}/dataPack/projectCurrent`, data);
  },
  saveDownLoadTaskByBiInfoId: data => {
    return request.post(`${baseUrl}/dataPack/saveDownLoadTaskByBiInfoId`, data);
  },
  getFenpeiIdList: data => {
    return request.post(`${baseUrl}/bi/biVisit/getFenpeiIdList`, data);
  },
  getFenpeiIdListV2: data => {
    return request.post(`${baseUrl}/v2/bi/biVisit/getFenpeiIdList`, data);
  },
  saveTSaasBiCustomReport: data => {
    return request.post(
      `${baseUrl}/bi/tSaasBiCustomReport/saveTSaasBiCustomReport`,
      data
    );
  },
  saveTSaasBiCustomReportV2: data => {
    return request.post(
      `${baseUrl}/v2/bi/biVisit/saveTSaasBiCustomReport`,
      data
    );
  },
  getCustomReportStartTime: data => {
    return request.post(
      `${baseUrl}/bi/tSaasBiCustomReport/getCustomReportStartTime`,
      data
    );
  },
  listTSaasBiCustomReport: async data => {
    const getFileName = fileUrl => {
      try {
        const name = fileUrl.match(/(?:.+\/)(.+)/)[1];
        return decodeURIComponent(name.split('.')[0]);
      } catch (error) {
        return fileUrl;
      }
    };
    // 改造接口
    const resp = await request.post(
      `${baseUrl}/bi/tSaasBiCustomReport/listTSaasBiCustomReport`,
      data
    );
    const {
      pdata: { list }
    } = resp;
    list.forEach(item => {
      // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
      if (!item.taskRecordUrls) {
        const oldUrl = item.downloadUrl || item.taskRecordUrl;
        if (oldUrl) {
          item.taskRecordUrls = [
            {
              downloadName: getFileName(oldUrl),
              downloadUrl: oldUrl,
              fileSize: item.fileSize || '-',
              urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
            }
          ];
        } else {
          item.taskRecordUrls = [];
        }
      }
    });
    return resp;
  },
  // 自定义下载
  listTSaasBiCustomReportV2: async data => {
    const getFileName = fileUrl => {
      try {
        const name = fileUrl.match(/(?:.+\/)(.+)/)[1];
        return decodeURIComponent(name.split('.')[0]);
      } catch (error) {
        return fileUrl;
      }
    };
    // 改造接口
    const resp = await request.post(
      `${baseUrl}/v2/bi/biVisit/listTSaasBiCustomReport`,
      data
    );
    const {
      pdata: { list }
    } = resp;
    list.forEach(item => {
      // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
      if (!item.taskRecordUrls) {
        const oldUrl = item.downloadUrl || item.taskRecordUrl;
        if (oldUrl) {
          item.taskRecordUrls = [
            {
              downloadName: getFileName(oldUrl),
              downloadUrl: oldUrl,
              fileSize: item.fileSize || '-',
              urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
            }
          ];
        } else {
          item.taskRecordUrls = [];
        }
      }
    });
    return resp;
  },
  getNumberQuestionBiStatus: data => {
    return request.post(`${baseUrl}/bi/nq/getNumberQuestionBiStatus`, data, {
      // yapi: '657'
    });
  },
  getNumberQuestionBiStatusV2: data => {
    return request.get(
      `${baseUrl}/v2/bi/biVisit/getNumberQuestionBiStatus`,
      { params: data },
      {
        // yapi: '657'
      }
    );
  }
};

export const makeSceneBi = {
  templateList: data => {
    return request.post(`${baseUrl}/bi/teamplate/listTemplate`, data, {
      // yapi: '657'
    });
  },
  baseInfo: data => {
    return request.post(`${baseUrl}/bi/makeScene/base/info`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return request.post(`${baseUrl}/bi/makeScene/fixed/info`, data, {
      // yapi: '657'
    });
  },
  topicInfo: data => {
    return request.post(`${baseUrl}/bi/makeScene/topic/info`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return request.post(`${baseUrl}/bi/makeScene/group/info`, data, {
      // yapi: '657'
    });
  },
  // 获取是否含有照片题
  getImageQuestionCount: data => {
    return request.post(`${baseUrl}/pw/getImageQuestionCount`, data, {
      // yapi: '657'
    });
  },
  // 当期BI-保持选择的图片
  saveBiPicList: data => {
    return request.post(`${baseUrl}/pw/saveBiPicList`, data, {
      // yapi: '657'
    });
  },
  // 当期BI-任务记录图片列表
  getTaskPicList: data => {
    return request.post(`${baseUrl}/pw/getTaskPicList`, data, {
      // yapi: '657'
    });
  },
  // 累计BI、自定义BI获取随机50张图片
  getImageList: data => {
    return request.post(`${baseUrl}/pw/getImageList`, data, {
      // yapi: '657'
    });
  },
  saveInfo: data => {
    return request.post(`${baseUrl}/bi/makeScene/info/save`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  download: `${baseUrl}/bi/makeScene/download`
};

export const hgtgBi = {
  baseInfo: data => {
    return request.post(`${baseUrl}/bi/hgtg/getHgtgBaseInfo`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return request.post(`${baseUrl}/bi/hgtg/getStyleConfigureFixed`, data, {
      // yapi: '657'
    });
  },
  topicInfo: data => {
    return request.post(`${baseUrl}/bi/hgtg/getStyleConfigureHgtg`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return request.post(`${baseUrl}/bi/hgtg/ListsingleContent`, data, {
      // yapi: '657'
    });
  },
  saveInfo: data => {
    return request.post(`${baseUrl}/bi/hgtg/updateHgtgBaseInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};

export const digitalQuestionnaireBi = {
  baseInfo: data => {
    return request.post(`${baseUrl}/bi/nq/getNumQuestBaseInfo`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return request.post(
      `${baseUrl}/bi/nq/getNumQuestStyleConfigureFixed`,
      data,
      {
        // yapi: '657'
      }
    );
  },
  topicInfo: data => {
    return request.post(`${baseUrl}/bi/nq/getNumQuestStyleConfigure`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return request.get(`${baseUrl}/bi/nq/getNumQuestBIPromoteCatalogueDetail`, {
      params: data
      // yapi: '657'
    });
  },
  saveInfo: data => {
    return request.post(`${baseUrl}/bi/nq/updateNumQuestBiInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};
/****************************************************生成订单-交付制****************************************************************/
// 认证详情
export const orderManagement = {
  // 生成订单-勾选人员结算信息（项目结算管理-结算列表）
  isCheck(data) {
    return request.post(`${baseUrl}/orderManagement/isCheck`, data);
  },
  // 订单备注列表查询
  remarkDesc(data) {
    return request.post(`${baseUrl}/myorder/remarkDesc`, data);
  },
  // 生成订单-项目列表(项目结算管理-结算列表)
  getSelectProjectList(data) {
    return request.post(
      `${baseUrl}/orderManagement/getSelectProjectList`,
      data
    );
  },
  // 生成订单-供应商列表(项目结算管理-结算列表)
  getSelectSupplierList(data) {
    return request.post(
      `${baseUrl}/orderManagement/getSelectSupplierList`,
      data
    );
  },
  // 生成订单-结算人员列表(项目结算管理-结算列表)
  getOrderPeopleList(data) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const res = await request.post(
        `${baseUrl}/orderManagement/getOrderPeopleList`,
        data
      );
      const {
        data: {
          data: { list }
        }
      } = res;

      res.data.data.list = list.map(i => ({
        ...i,
        _customizeNum: i.finishSum
      }));
      resolve(res);
    });
  },
  // 生成订单-【确认笔数、订单信息确认】 列表(项目结算管理-结算列表)
  getConfirmOrderPeopleList(data) {
    return request.post(
      `${baseUrl}/orderManagement/getConfirmOrderPeopleList`,
      data
    );
  },
  // 生成订单- 统计已选笔数、项目支付总计金额、项目统计(项目结算管理-结算列表)
  countSelectBill(data) {
    return request.post(`${baseUrl}/orderManagement/countSelectBill`, data);
  },
  // 确认生成订单(项目结算管理-结算列表)
  generateOrder(data) {
    return request.post(`${baseUrl}/orderManagement/generateOrder`, data);
  },
  // 失效订单-重新生成订单(我的订单-失效)
  rebuildOrder(data) {
    return request.post(`${baseUrl}/orderManagement/rebuildOrder`, data);
  },
  // 项目结算单列表(项目结算单管理)
  settlementList(data) {
    return request.post(`${baseUrl}/orderManagement/settlementList`, data);
  },
  // 项目结算管理-支付进度
  listPaySchedule(data) {
    return request.post(`${baseUrl}/orderManagement/listPaySchedule`, data);
  },
  // 项目结算管理-订单详情
  orderDetails(data) {
    return request.post(`${baseUrl}/orderManagement/orderDetails`, data);
  }
};
/******************************************************交付制*********************************************************************/
// 項目人員 批量启用/停用 http://yapi.jimijiayuan.cn/project/657/interface/api/20453
export const enableDisablePeopleProject = data => {
  return request.post(
    `${baseUrl}/ProjectPersonnelManagement/enableDisablePeopleProject`,
    data
  );
};
// 項目人員 启用/停用 http://yapi.jimijiayuan.cn/project/657/interface/api/20471
export const enableDisablePeopleProjectUser = data => {
  return request.post(
    `${baseUrl}/ProjectPersonnelManagement/enableDisablePeopleProjectUser`,
    data
  );
};

// 项目人员-选择人员-批量启用停用(新-0330运营优化)
export const batchStatus = data => {
  return request.post(`${baseUrl}/peopleProject/batchStatus`, data, {
    notUseQs: true,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  });
};

// 项目人员-名单操作-单独添加(数据分仓-用户校验)
export const checkoutPhone = data => {
  return request.post(`${baseUrl}/peopleProject/checkoutPhone`, data);
};

//编辑项目-保存按钮
export const addUpdateProjectV2 = data => {
  return request.post(`${baseUrl}/projectV2/addUpdateProjectV2`, data);
};

//编辑项目-保存按钮提交审核
export const submitProjectAudit = data => {
  return request.post(`${baseUrl}/projectV2/submitProjectAudit`, data);
};
//判断是否可以设置 按期展示 或者 按累计展示，如果 taskShowType === null,则可以设置
export const projectInfoNew = data => {
  return request.post(
    `${baseUrl}/ProjectPersonnelManagement/projectInfoNew`,
    data
    // {
    //   yapi: '657' //FIXME：生产去掉
    // }
  );
};

//预采购任务 下载数据模板
export const projectTaskPlanTemplate = `${baseUrl}/downLoadTemplate/projectTaskPlanTemplate`;
//预采购任务 下载预采购历史数据
export const projectTaskPlanExcel = `${baseUrl}/downLoadTemplate/projectTaskPlanExcel`;

//提交任务 - 待提交任务列表  http://yapi.jimijiayuan.cn/project/657/interface/api/20795
export const listWaitTaskRecords = data => {
  return request.post(`${baseUrl}/confirm/listWaitTaskRecords`, data, {
    // yapi: '657'
  });
};
//导出未入驻的，未签合同的用户
export const exportUnqualifyUser = `${baseUrl}/confirm/exportUnqualifyUser`;

//校验导入错误弹层继续提交
export const continueSubmit = data => {
  return request.post(`${baseUrl}/confirm/continueSubmit`, data, {
    // yapi: '657'
  });
};

export const taskRecordRevocation = data => {
  return request.post(`${baseUrl}/confirm/revocation`, data, {
    // yapi: '657'
  });
};
export const checkAcceptanceAndAudit = data => {
  return request.post(`${baseUrl}/dataPack/checkAcceptanceAndAudit`, data, {
    // yapi: '645/24451'
  });
};
export const selectAllTaskRecords = data => {
  return request.post(`${baseUrl}/confirm/selectAllTaskRecords`, data, {});
};
export const statisticTips = data => {
  return request.post(`${baseUrl}/confirm/statisticTips`, data, {
    // yapi: '657'
  });
};
//提交任务 - 生成提交任务列表  http://yapi.jimijiayuan.cn/project/657/interface/api/20795
export const listManualTaskRecords = data => {
  return request.post(`${baseUrl}/confirm/listManualTaskRecords`, data, {
    // yapi: '657'
  });
};
//提交任务 - 待提交任务 修改提交任务量 缓存  http://yapi.jimijiayuan.cn/project/657/interface/api/20837
export const cacheRecordNum = data => {
  return request.post(`${baseUrl}/confirm/cacheRecordNum`, data, {
    // yapi: '657'
  });
};

//提交任务 - 提交任务记录  http://yapi.jimijiayuan.cn/project/657/interface/api/20837
export const listPurchaseRecord = data => {
  return request.post(`${baseUrl}/confirm/listPurchaseRecord`, data, {
    // yapi: '657'
  });
};

//提交任务 - 删除 缓存任务表中的任务 http://yapi.jimijiayuan.cn/project/657/interface/api/20837
export const removeCache = data => {
  return request.post(`${baseUrl}/confirm/removeCache`, data, {
    // yapi: '657'
  });
};
//提交任务 - 删除超量缓存key
export const removeKey = data => {
  return request.post(`${baseUrl}/confirm/removeKey`, data, {
    // yapi: '657'
  });
};
//提交任务 - 缓存任务表中的任务 http://yapi.jimijiayuan.cn/project/657/interface/api/20837
export const preventWebpackZip = {
  listTaskRecords(data) {
    return request.post(`${baseUrl}/confirm/listTaskRecords`, data, {
      // yapi: '657'
    });
  },
  //超量缓存列表
  listExcessTaskRecords(data) {
    return request.post(`${baseUrl}/confirm/listExcessTaskRecords`, data, {
      // yapi: '657'
    });
  }
};

//提交任务 - 提交 缓存任务表 生成结算单 http://yapi.jimijiayuan.cn/project/657/interface/api/20837
export const createStatement = data => {
  return request.post(`${baseUrl}/confirm/createStatement`, data, {
    // yapi: '657'
  });
};
//提交任务 - 提交任务 结算单保存 之前
export const getDataStatus = data => {
  return request.post(`${baseUrl}/confirm/getDataStatus`, data, {
    // yapi: '657'
  });
};
//提交任务 - 提交任务 - 项目BI之前 - 结算单保存  http://yapi.jimijiayuan.cn/project/657/interface/api/20861
export const saveStatement = data => {
  return request.post(`${baseUrl}/confirm/saveStatement`, data, {
    // yapi: '657'
  });
};
//提交任务 - 提交任务 - 编辑BI - 提交  http://yapi.jimijiayuan.cn/project/657/interface/api/21047
export const commitStatement = data => {
  return request.post(`${baseUrl}/confirm/commitStatement`, data, {
    // yapi: '657'
  });
};
// 根据 项目收入 和税率 计算 收入和服务费
export const calcAmount = data => {
  return request.post(`${baseUrl}/confirm/calcAmount`, data, {
    // yapi: '657'
  });
};
// 提交记录 - 重新提交
export const recommit = data => {
  return request.post(`${baseUrl}/confirm/recommit`, data);
};

/****************************************************任务记录--交付制****************************************************************/
// 审核记录是否合规 # http://yapi.jimijiayuan.cn/project/657/interface/api/20891
export const approvalRecord = data => {
  return request.post(`${baseUrl}/record/approvalRecord`, data);
};

// 记录详情-审核状态 # http://yapi.jimijiayuan.cn/project/657/interface/api/20891
export const getRecordStateInfo = data => {
  return request.post(`${baseUrl}/record/getRecordStateInfo`, data);
};
//清空预采购任务量
export const importProjectTaskPlanDel = data => {
  return request.post(
    `${baseUrl}/importInAdvance/importProjectTaskPlanDel`,
    data
  );
};

// 判断项目是否已经开始
export const checkProjectIsStart = data => {
  return request.post(`${baseUrl}/importInAdvance/checkProjectIsStart`, data);
};

export const taxPayment = {
  // 服务商下拉列表
  selectBox: data => {
    return request.post(`${baseUrl}/taxPayment/selectBox`, data);
  },
  // 完税证明列表
  list: data => {
    return request.post(`${baseUrl}/taxPayment/list`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 新增完税证明
  add: data => {
    return request.post(`${baseUrl}/taxPayment/add`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 完税证明 - 通过ID查看
  detail: data => {
    return request.post(`${baseUrl}/taxPayment/id`, data);
  },
  // 完税证明 - 通过ID下载
  downloadAnnex: `${baseUrl}/taxPayment/downloadAnnex`,

  // 完税证明 - 通过ID下载 - ajax方式
  downloadAnnexAjax: data => {
    return request.post(`${baseUrl}/taxPayment/downloadAnnex`, data);
  },

  // 客户企业
  settleCompany: data => {
    return request.post(`${baseUrl}/taxPayment/settleCompany`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  fileUploadTaxPaymentAnnex: `${baseUrl}/upload/taxPaymentAnnex`,

  // 客户企业
  enterpriseType: data => {
    return request.post(`${baseUrl}/taxPayment/enterpriseType`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 个体自然人完税列表
  individualNaturalPersonList: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/list`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      }
    );
  },

  // 新增完税个体下拉框：当前服务商导入过项目且注册成功个体信息的
  selIndividualList: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/selIndividualList`,
      data
    );
  },
  // 个体自然人-新增完税
  addTaxPayment: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/addTaxPayment`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      }
    );
  },
  // 个体自然人-个体完税下载（批量，单个）
  individualNaturalPersonDownload: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/download`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      }
    );
  },
  // 新增完税个体：列表查看详情
  proofAttById: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/proofAttById`,
      data
    );
  },
  // 查看当前企业是否为特殊企业 只有特殊企业才有新增上传 0否 1是
  getEntType: data => {
    return request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/getEntType`,
      data
    );
  },
  /**
   * 查看当前项目是否可以导入人员 true可导入 false 不可导入
   * @param {projectId:number} data
   * @returns
   */
  checkExportPersonnel: async data => {
    const loading = Loading.service({
      fullscreen: true,
      text: '加载中...'
    });
    const res = await request.post(
      `${baseUrl}/individualNaturalPerson/taxPayment/checkExportPersonnel`,
      data
    );
    let status = true;
    try {
      status = res.data.data;
    } catch (error) {
      console.warn(error);
    }
    loading.close();
    if (status) {
      return Promise.resolve('可导入');
    } else {
      MessageBox({
        title: '',
        message: '您没有绑定用工平台ID，请联系平台运营人员处理。',
        confirmButtonText: '关闭',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true
      });
      return Promise.reject('不可导入');
    }
  }
};

export const invoiceNew = {
  // 客户企业
  listSelectEnterprise: data => {
    return request.post(`${baseUrl}/invoice/listSelectEnterprise`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  listInvoice: data => {
    return request.post(`${baseUrl}/invoice/listInvoice`, data);
  },
  detail: data => {
    return request.post(`${baseUrl}/invoice/id`, data);
  },
  queryLogisticsCompany: data => {
    return request.post(`${baseUrl}/invoice/queryLogisticsCompany`, data);
  },
  saveInvoiceDetail: data => {
    return request.post(`${baseUrl}/invoice/saveInvoiceDetail`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 判断该企业是否参与过特殊企业的项目
  invoiceCheck(data) {
    return request.post(
      `${baseUrl}/individualNaturalPerson/invoice/check`,
      data
    );
  },
  // 判断该企业是否参与过特殊企业的项目
  specialTypeAndStatus(data) {
    return request.post(
      `${baseUrl}/individualNaturalPerson/invoice/specialTypeAndStatus`,
      data
    );
  },
  info(data) {
    return request.post(
      `${baseUrl}/individualNaturalPerson/invoice/info`,
      data
    );
  },
  getGongyeEnterprise: data => {
    return request.post(`${baseUrl}/invoice/getGongyeEnterprise`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  editCsoInfo: data => {
    return request.post(`${baseUrl}/invoice/modifyIndustryEnterprise`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  deleteCsoInfo: data => {
    return request.post(
      `${baseUrl}/invoice/delete/invoiceCsoInfoCommonId`,
      data
    );
  },

  getCsoInvoiceCate: data => {
    return request.post(`${baseUrl}/invoice/getCsoInvoiceCate`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  editCsoItem: data => {
    return request.post(`${baseUrl}/invoice/edit/invoiceCsoItemId`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  deleteCsoItem: data => {
    return request.post(`${baseUrl}/invoice/delete/invoiceCsoItemId`, data);
  },

  addInvoiceApply: data => {
    return request.post(`${baseUrl}/invoice/addInvoiceApply`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};
// 快捷回复 审核不通过快捷回复
export const fastReply = {
  get: data => {
    //获取快捷回复列表：http://yapi.jimijiayuan.cn/project/657/interface/api/22475
    return request.post(`${baseUrl}/opinion/list`, data);
  },
  delete: data => {
    // 删除快捷回复信息 http://yapi.jimijiayuan.cn/project/657/interface/api/22481
    return request.post(`${baseUrl}/opinion/delete`, data);
  }
};

// 任务记录
export const record = {
  openExcessAudit: data => {
    // 是否“超量审核开关”， http://yapi.jimijiayuan.cn/project/657/interface/api/22469
    return request.post(`${baseUrl}/record/openExcessAudit`, data);
  }
};

// 是否显示审核人姓名
export const projectCsoAuditShow = data => {
  return request.post(`${baseUrl}/makeSceneTask/projectCsoAuditShow`, data);
};
// 园区下拉框 -- 添加名单使用
export const park = {
  getOptions: () => {
    return new Promise(resolve => {
      const res = {
        data: {
          status: 1,
          message: '操作成功',
          code: '1',
          data: { list: [] }
        }
      };
      resolve(res);
    });
    // return request.post(`${baseUrl}/newEntity/getList`,data);
  }
};
export const peopleMgmt = {
  uploadError: `${baseUrl}/downLoadTemplate/importUserOrTaskExcel`
};
//超量导出
export const exportExcessRecords = `${baseUrl}/confirm/exportExcessRecords`;

//活动
export const activity = {
  // 活动列表
  list: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/listOfActivities`,
      data
    );
  },
  // 添加活动
  add: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/addActivities`,
      data
    );
  },
  // 更新活动
  update: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/updateActivities`,
      data
    );
  },
  // 查看附件（详情）
  detail: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivityPeople/activityFileDetail`,
      data
    );
  },
  //删除附件
  deleteFile: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivityPeople/deleteFile`,
      data
    );
  },
  // 提交活动
  submit: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/submitActivity`,
      data
    );
  },
  // 协定服务活动-活动人员删除
  delPerson: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/delActivitiesPeople`,
      data
    );
  },
  // 添加人员-下载模板
  downloadPersonTemplate: `${baseUrl}/downLoadTemplate/personnelActivityDownLoad`,
  // 添加人员-导入提交
  uploadPersons: `${baseUrl}/agreementServicesActivity/addActivitiesPeopleImport`,
  // 上传附件-提交
  submitUploadFile: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/submitUploadFile`,
      data
    );
  },
  // 导出活动参与人列表
  exportList: `${baseUrl}/agreementServicesActivityPeople/exportList`
};

// 活动参与人
export const activityPerson = {
  list: data => {
    const body = Object.keys(data).reduce((clc, cur) => {
      if (cur === 'serviceActivityId') {
        // 数据库单词写错了，不在这里改的话，页面要改4个地方
        clc['sersviceActivityId'] = data['serviceActivityId'];
      }
      clc[cur] = data[cur];
      return clc;
    }, {});
    return request.post(
      `${baseUrl}/agreementServicesActivityPeople/list`,
      body
    );
  },
  add: data => {
    return request.post(
      `${baseUrl}/agreementServicesActivity/addActivitiesPeople`,
      data
    );
  }
};
// 预采购任务量改版2022
export const importProjectPeople = {
  //错误列表
  importExcelErrorList(data) {
    return request.post(
      `${baseUrl}/importProjectPeople/importExcelErrorList`,
      data
    );
  },
  //下载错误数据
  importExcelErrorDownLod: `${baseUrl}/importProjectPeople/importExcelErrorDownLod`,
  //导入预采购任务量 upload
  importExcelNewActionUrl: `${baseUrl}/importProjectPeople/importExcelNew`,
  //导入预采购任务量
  importExcelNew(data) {
    return request.post(`${baseUrl}/importProjectPeople/importExcelNew`, data);
  }
};

export const confirm = {
  showTheHiddenImageVersion(data) {
    return request.post(`${baseUrl}/confirm/showTheHiddenImageVersion`, data);
  }
};
export const accountManagement = {
  //-----------------------  子账号管理  -----------------------//
  obtainIndustryEnterprise(data) {
    //上游企业列表
    return request.post(`${baseUrl}/projectV2/obtainIndustryEnterprise`, data);
  },
  subaccountManagementList(data) {
    return request.post(`${baseUrl}/subaccountManagement/List`, data);
  },
  subaccountManagementRoleList(data) {
    return request.post(`${baseUrl}/subaccountManagement/roleList`, data);
  },
  roleAddOrEdit(data) {
    return request.post(`${baseUrl}/subaccountManagement/roleAddOrEdit`, data);
  },
  roleDelete(data) {
    return request.post(`${baseUrl}/subaccountManagement/roleDelete`, data);
  },
  status(data) {
    return request.post(`${baseUrl}/subaccountManagement/status`, data);
  },
  theNewAccountOrEdit(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/theNewAccountOrEdit`,
      data
    );
  },
  logout(data) {
    return request.post(`${baseUrl}/subaccountManagement/logout`, data);
  },
  cancelLogout(data) {
    return request.post(`${baseUrl}/subaccountManagement/cancelLogout`, data);
  },
  queryLimitsOfAuthority(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/queryLimitsOfAuthority`,
      data
    );
  },
  userProjectQuery(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/userProjectQuery`,
      data
    );
  },
  userProjectAddOrEdit(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/userProjectAddOrEdit`,
      data,
      {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      }
    );
  },
  userProjectQueryExtend(data) {
    return request.post(
      `${baseUrl}/subaccountManagement/userProjectQueryExtend`,
      data
    );
  },
  //-----------------------  主账号管理  -----------------------//
  masterAccountManagementList(data) {
    return request.post(`${baseUrl}/masterAccount/get`, data);
  },
  masterAccountEditPassWD(data) {
    return request.post(`${baseUrl}/masterAccount/editPassWD`, data);
  },
  sendMessageCode(data) {
    return request.post(`${baseUrl}/user/sendMessageCode`, data);
  },
  sendMessageCodeForUpdatePwd(data) {
    return request.post(`${baseUrl}/user/sendMessageCodeForUpdatePwd`, data);
  },
  verifyImgCode: `${baseUrl}/user/verifyImgCode`,
  getVerification(data) {
    return request.post(
      `${baseUrl}/get/verification/imageJson?type=slide`,
      data
    );
  },
  //-----------------------  操作日志  -----------------------//
  operationLogList(data) {
    return request.post(`${baseUrl}/operationLog/getPageList`, data);
  },
  operationLogExport: `${baseUrl}/operationLog/export`,
  viewOperationLog(data) {
    return request.post(`${baseUrl}/operationLog/viewOperationLog`, data);
  },
  getLogDetail(data) {
    return request.post(`${baseUrl}/operationLog/getLogDetail`, data);
  },
  listLogType(data) {
    return request.post(`${baseUrl}/operationLog/listLogType`, data);
  }
};
/****************************************************版本控制****************************************************************/
export const clientVersion = {
  getVersion: data => request.post(`${baseUrl}/clientVersion/getVersion`, data)
};
/****************************************************账户系统-支付通道****************************************************************/
export const account = {
  validateUserPassageway: data =>
    request.post(`${baseUrl}/confirm/validateUserPassageway`, data),
  listUnOpenPayUser: data =>
    request.post(`${baseUrl}/confirm/listUnOpenPayUser`, data),
  downUnOpenPayByUserIds: `${baseUrl}/confirm/downUnOpenPayByUserIds`,
  removeUnOpenCache: data =>
    request.post(`${baseUrl}/confirm/removeUnOpenCache`, data),
  getUserInfo: data =>
    request.post(`${baseUrl}/accountUserInfo/getUserInfo`, data),
  /**
   * 支付通道下拉列表查询
   * @param {
   * passagewayStatus: 通道状态 1 启用 2 停用
   * } data
   */
  queryPayPassageway(data) {
    return request.post(`${baseUrl}/common/queryPayPassageway`, data);
  },
  /**
   * 字典查询接口
   * @param {
   * dicCode: pay_passage_way 支付通道
   * } data
   */
  queryByCode(data) {
    return request.post(`${baseUrl}/common/queryByCode`, data);
  }
};

// 检查结算中心是否需要展示终端支付管理菜单
export const checkTerminalPayMgr = data => {
  return request.post(`${baseUrl}/terminalPayMgr/check`, data);
};
// 判断服务商是否存在商户服务费项目
export const existsBusService = data => {
  return request.post(`${baseUrl}/myorder/existsBusService`, data);
};
/****************************************************项目资质审核****************************************************************/
export const certification = {
  // 项目是否需要 资质审核
  queryProjectExtendCertification: data =>
    request.post(
      `${baseUrl}/userEnterPject/queryProjectExtendCertification`,
      data
    ),
  // 获取项目的 资质审核
  queryCertificationList: data =>
    request.post(
      `${baseUrl}/ProjectPersonnelManagement/queryCertificationList`,
      data
    ),
  // 审核 资质
  projectPersonnelAudit: data =>
    request.post(`${baseUrl}/userEnterPject/projectPersonnelAudit`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    }),
  // 资质详情
  queryCertificationProjectUserDetail: data =>
    request.post(
      `${baseUrl}/userEnterPject/queryCertificationProjectUserDetail`,
      data
    )
};
// 判断业务说明 http://yapi.jimijiayuan.cn/project/657/interface/api/27651
export const bizDesc = data => {
  return request.post(`${baseUrl}/project/bizDesc`, data);
};
/****************************************************线下网银支付****************************************************************/
//获取网银支付结算单支付信息
export const getOffLineUserOpen = data => {
  return request.post(`${baseUrl}/OffLineUserOpen/getOffLineUserOpen`, data);
};
//提交网银支付结算单支付信息
export const saveOrUpdateOffLineUserOpen = data => {
  return request.post(
    `${baseUrl}/OffLineUserOpen/saveOrUpdateOffLineUserOpen`,
    data
  );
};
/****************************************************BI编辑模块****************************************************************/
export const biTmplIsHidden = () =>
  request.get(`${baseUrl}/bi/v3/tmpl/isHidden`); //是否隐藏提交材料菜单（bi模板编辑）

/****************************************************招商管理****************************************************************/
export const zsManageIsHidden = () =>
  request.get(`${baseUrl}/zs/config/zsStatus`); //查询招商状态（权限）
